import { Component } from '@angular/core';
import { NavController, NavParams, ModalController, PopoverController, LoadingController, App } from 'ionic-angular';
import { CurrLotteryModel, DollerAttr, AnBetting, ChaseBetting, StorageLottery } from '../../models/betting.model';
import { BettingService } from '../../services/betting.service';
import { BettingListPage } from './bettingList';
import { StorageService } from '../../providers/storage.service';
import { List } from "linqts";
import * as $ from 'jquery';
import { AlertService } from '../../providers/alert.service';
import { AppConfig } from '../../app/app.config';
import { LoaddingService } from '../../providers/loadding.service';
import { GroupByPipe } from "ng-pipes/src";
import { BettingOrderHelper } from "../bettingorder/bettingorder.helper";
import { SigninPage } from '../signin/signin';
import { UserMoneyPage } from '../bettingorder/reward';
import { UserVarifyService } from '../../services/userVarify.service';
import { UserModel } from '../../models/user.model';
import { KQBounsParamsModel } from '../../models/credit.model';
import { SysconfigService } from '../../services/sysconfig.service';
import { BettingParamService } from "./../../services/betting.param.service";
import { FixedExtend } from '../../config/fixed-extend';
// import { KQBounsService } from '../../providers/kqbouns.server';

// @IonicPage()
@Component({
    selector: 'page-dollars',
    templateUrl: 'dollars.html',
    providers: [BettingService, BettingParamService, UserVarifyService]
})

export class DollarsPage {
    currentDail;
    currUser: UserModel = new UserModel();
    initCurrLottery: any;
    currlDollarCode: string;
    currlDollarType: number;
    rootNavCtrl: NavController;
    parentPage: any;
    cucumber: boolean;
    sysconfig;
    currLottery;
    setIntervalid: any;
    isOne = 0;
    isEye: boolean;
    kqParams: KQBounsParamsModel;
    kqBettingMoney: number = 1;        //默认快钱玩法投注金额
    isshowmask: boolean = false;
    isshowMask: boolean = false;
    midValue;
    unclick: boolean = true;
    public static liuHeCaiyear;

    /**
    * 组选6已选tab
    *
    * @type {String}
    * @memberof DollarsPage
    */
    treeGroupName: String = '前三';
    kqHighFrequencyPerMaxReward: any;
    headsupRatio: any;
    HeadsupRewardMax: any;

    constructor(
        public navCtrl: NavController,
        public navParams: NavParams,
        private loadingCtrl: LoadingController,
        private bettingService: BettingService,
        public modalCtrl: ModalController,
        private bettinghelper: BettingOrderHelper,
        private groupBy: GroupByPipe,
        private config: AppConfig,
        private loadding: LoaddingService,
        private storage: StorageService,
        private alert: AlertService,
        private appCtrl: App,
        private popCtrl: PopoverController,
        private userService: UserVarifyService,
        private sys: SysconfigService,
        private bettingParam: BettingParamService,
        private indexExtend: FixedExtend,

        // private kqBetParams: KQBounsService,

    ) {
        this.currlDollarCode = navParams.get('code');
        this.currlDollarType = navParams.get('type');
        this.rootNavCtrl = this.navParams.get('rootNavCtrl');
        this.parentPage = this.navParams.get('parentPage');
        this.currLottery = this.navParams.get('currLottery');
        this.currentDail = this.navParams.get('currentDeail');
        this.sysconfig = this.config.getSysConfig();//获取角色权限信息
        this.headsupRatio = this.sysconfig.HeadsupRatio;
        this.HeadsupRewardMax = this.sysconfig.HeadsupRewardMax;
        this.kqHighFrequencyPerMaxReward = this.sysconfig.KqHighFrequencyPerMaxReward;
        this.currUser = this.config.getCurrentUser();//获取登录信息
        AppConfig.peruserMoney = this.currUser && this.currUser.UserMoney != null
            ? this.currUser.UserMoney
            : AppConfig.peruserMoney;
        this.dollarInit.bettingItemData = new BettingMoneyCountModel();
    }
    dollarInit = new dollarInitParams();
    segments = [
        {
            value: "",
            name: "前三"
        },
        {
            value: "",
            name: "中三"
        },
        {
            value: "",
            name: "后三"
        },

    ];//二字组合tap渲染，因为组件BUG，目前先写死
    playDollarModes = {
        PlayModes: [],
        PlayModesName: "信用玩法",
        PlayModeType: 1
    };//快钱玩法
    openType: string;
    isString: any = [];
    groupTreeArray = [];  //组选三或者组选6临时选中的数据
    zodiacArr = ["鼠", "牛", "虎", "兔", "龙", "蛇", "马", "羊", "猴", "鸡", "狗", "猪"];
    markSixCardinal: number = 0;
    tempSexCardArr = [];
    canBetting: boolean = true; //判断购彩栏是否有注数
    AppConfig = AppConfig;
    ionViewWillLoad() {
        this.showLoading();
    }

    ionViewDidLoad() {
        let instance = this.getBettingPage();
        this.initCurrLottery = this.currLottery;
        this.dollarInit.minnum = instance.initall.minnum;
        this.dollarInit.maxnum = instance.initall.maxnum;
        this.dollarInit.rangeValue = instance.initall.rangeValue;
        this.dollarInit.BonusMode = instance.initall.BonusMode;
        this.dollarInit.baseReward = instance.initall.baseReward;
        this.dollarInit.rewardUp = instance.initall.rewardUp;
        this.playDollarModes.PlayModes = instance.playDollarModes.PlayModes;
        this.initUserOdds(this.initCurrLottery);
        let playModeDetail = (new List(this.playDollarModes.PlayModes).Where(s => {
            return s['LotteryPlayModeCode'] == this.currlDollarCode;
        })).ToArray();
        this.dollarInit.bettingItemData.LotteryPlayModeCode = this.currlDollarCode;
        this.dollarInit.bettingItemData.LotteryCode = instance.lotteryCode;
        this.dollarInit.currlottery.PlayMode = playModeDetail[0];
        this.fontDollarsAttr(this.currlDollarType);
        this.initDollarsDetaile();
    }
    /**
    * 初始化块钱玩法的赔率
    */
    initUserOdds(dataLottery) {
        let __this = this;
        dataLottery.PlayModes.forEach((mode, i) => {
            if (mode.PlayModeType == 1 && mode.PlayDetails.length > 0) {
                mode.PlayDetails.forEach((detail, j) => {
                    var cardinalMoney = detail.CardinalMoney,
                        rewardUp = this.dollarInit.BonusMode[1],
                        modulus = detail.Modulus;
                    detail.CardinalMoney1 = __this.countOdds(cardinalMoney, rewardUp, modulus);
                });
            }
        });
    }

    ionViewWillEnter() {
    }

    ionViewDidEnter() {
        let instance = this.getBettingPage();
        this.currUser = this.config.getCurrentUser();
        if (this.currUser && this.currUser.UserMoney != null) {
            AppConfig.peruserMoney = this.currUser.UserMoney;
        }
        this.reUserMoney();
        this.dollarInit.bettingItemData.IssueNo = instance.initall.currIssue.CurrentIssueNo;
        this.dollarInit.rangeValue = instance.initall.rangeValue;
        this.dollarInit.BonusMode = instance.initall.BonusMode;
        this.dollarInit.newDollarsBetting.forEach(v => {
            v.newParam.forEach(element => {
                element.tr.forEach(z => {
                    z.check = false;
                })
            });
        })
        this.dollarInit.bettingItemData.noteTotal = 0;
        this.dollarInit.bettingItemData.BettingMoney = 0;
        this.dollarInit.bettingItemData.BettingItemList = [];
        this.groupTreeArray = [];
        this.tempSexCardArr = [];
        this.recombineDollars();
        // this.shortcutReset();
        // this.reset();
        // 修复快钱切换官方底部空白的问题
        document.querySelector('page-bettingorder .scroll-content').setAttribute('style', 'margin-top: 48px;margin-bottom: 0');
    }
    ionViewDidLeave() {
    }

    ionViewWillLeave() {  //当将要从页面离开时触发
        let instance = this.getBettingPage();
        instance.initall.rangeValue = this.dollarInit.rangeValue;
        instance.initall.BonusMode = this.dollarInit.BonusMode;
    }

    getBettingPage() {
        if (this.parentPage) {
            return this.parentPage;
        }
        let views = this.rootNavCtrl["_views"];
        return views.length > 2 ? views[2].instance : views[1].instance;
    }
    //获取当前期号，上期期号，当前期号结束剩余时间
    getIssue(fn) {
        this.bettingService.getIssue(this.dollarInit.bettingItemData.LotteryCode).then(s => {
            if (!s || s.CurrentIssueNo == "-1") {
                this.alert.showAlert("当前彩种停盘中");
                return;
            }
            fn(s);
        }).catch(c => {
            this.alert.showAlert("出现错误");
        });
    }
    //显示余额
    oprinerLet(event) {
        let popover = this.popCtrl.create(UserMoneyPage, { UserMoney: this.currUser.UserMoney }, { cssClass: "usermoney" });
        popover.present({
            ev: event
        });
    }

    /**
     * 筹码点击事件响应
     * evan 2018-11-06
     * @param {Number} money 
     * @memberof BettingBonusComponent
     */
    btnChangeMoney(money: number) {
        this.kqBettingMoney = money;
    }
    // 刷新用户余额
    reUserMoney() {
        this.userService.getUserMoney().then(s => {
            AppConfig.peruserMoney = s;
            let user = this.storage.read<UserModel>("User");
            $.extend(user, { 'UserMoney': s });
            this.storage.write("User", user);
            AppConfig.User = user;
        }).catch(() => {

        });
    }
    showMoney() {
        this.isEye = !this.isEye;
    }
    /*
    投注注数验证
    */
    checkBetting(tempBet) {
        if (tempBet.currLotteryPlayDetailName == "二全中" || tempBet.currLotteryPlayDetailName == "二中特之中特" ||
            tempBet.currLotteryPlayDetailName == "特串" || tempBet.currLotteryPlayDetailName == "二肖" || tempBet.currLotteryPlayDetailName == "二肖连中"
            || tempBet.currLotteryPlayDetailName.indexOf("二尾") > -1) {
            if (this.tempSexCardArr.length < 2) {
                this.canBetting = false;
                this.alert.showAlert("请在" + tempBet.currLotteryPlayDetailName + "中选择2个以上号码进行投注！");
                return;
            } else {
                this.canBetting = true;
            }
        } else if (tempBet.currLotteryPlayDetailName == "三全中" || tempBet.currLotteryPlayDetailName == "三中二之中二"
            || tempBet.currLotteryPlayDetailName == "三肖" || tempBet.currLotteryPlayDetailName.indexOf("三尾") > -1
            || tempBet.currLotteryPlayDetailName == "三肖连中") {
            if (this.tempSexCardArr.length < 3) {
                this.canBetting = false;
                this.alert.showAlert("请在" + tempBet.currLotteryPlayDetailName + "中选择3个以上号码进行投注！");
                return;
            } else {
                this.canBetting = true;
            }
        } else if (tempBet.currLotteryPlayDetailName == "四中一" || tempBet.currLotteryPlayDetailName == "四肖"
            || tempBet.currLotteryPlayDetailName.indexOf("四尾") > -1 || tempBet.currLotteryPlayDetailName == "四肖连中") {
            if (this.tempSexCardArr.length < 4) {
                this.canBetting = false;
                this.alert.showAlert("请在" + tempBet.currLotteryPlayDetailName + "中选择4个以上号码进行投注！");
                return;
            } else {
                this.canBetting = true;
            }
        } else if (tempBet.currLotteryPlayDetailName == "五肖" || tempBet.currLotteryPlayDetailName == "五不中"
            || tempBet.currLotteryPlayDetailName == "五肖连中") {
            if (this.tempSexCardArr.length < 5) {
                this.canBetting = false;
                this.alert.showAlert("请在" + tempBet.currLotteryPlayDetailName + "中选择5个以上号码进行投注！");
                return;
            } else {
                this.canBetting = true;
            }
        } else if (tempBet.currLotteryPlayDetailName == "六肖" || tempBet.currLotteryPlayDetailName == "六不中") {
            if (this.tempSexCardArr.length < 6) {
                this.canBetting = false;
                this.alert.showAlert("请在" + tempBet.currLotteryPlayDetailName + "中选择6个以上号码进行投注！");
                return;
            } else {
                this.canBetting = true;
            }
        } else if (tempBet.currLotteryPlayDetailName == "七肖" || tempBet.currLotteryPlayDetailName == "七不中") {
            if (this.tempSexCardArr.length < 7) {
                this.canBetting = false;
                this.alert.showAlert("请在" + tempBet.currLotteryPlayDetailName + "中选择7个以上号码进行投注！");
                return;
            } else {
                this.canBetting = true;
            }
        } else if (tempBet.currLotteryPlayDetailName == "八肖" || tempBet.currLotteryPlayDetailName == "八不中") {
            if (this.tempSexCardArr.length < 8) {
                this.canBetting = false;
                this.alert.showAlert("请在" + tempBet.currLotteryPlayDetailName + "中选择8个以上号码进行投注！");
                return;
            } else {
                this.canBetting = true;
            }
        } else if (tempBet.currLotteryPlayDetailName == "九肖" || tempBet.currLotteryPlayDetailName == "九不中") {
            if (this.tempSexCardArr.length < 9) {
                this.canBetting = false;
                this.alert.showAlert("请在" + tempBet.currLotteryPlayDetailName + "中选择9个以上号码进行投注！");
                return;
            } else {
                this.canBetting = true;
            }
        } else if (tempBet.currLotteryPlayDetailName == "十肖" || tempBet.currLotteryPlayDetailName == "十不中") {
            if (this.tempSexCardArr.length < 10) {
                this.canBetting = false;
                this.alert.showAlert("请在" + tempBet.currLotteryPlayDetailName + "中选择10个以上号码进行投注！");
                return;
            } else {
                this.canBetting = true;
            }
        } else if (tempBet.currLotteryPlayDetailName == "十一肖" || tempBet.currLotteryPlayDetailName == "十一不中") {
            if (this.tempSexCardArr.length < 11) {
                this.canBetting = false;
                this.alert.showAlert("请在" + tempBet.currLotteryPlayDetailName + "中选择11个以上号码进行投注！");
                return;
            } else {
                this.canBetting = true;
            }
        } else if (tempBet.currLotteryPlayDetailName == "十二不中") {
            if (this.tempSexCardArr.length < 12) {
                this.canBetting = false;
                this.alert.showAlert("请在" + tempBet.currLotteryPlayDetailName + "中选择12个以上号码进行投注！");
                return;
            } else {
                this.canBetting = true;
            }
        }
    }

    presentProfileModal() {
        if (!this.tempSexCardArr[0] && (this.currlDollarType == 40 || this.currlDollarType == 39)) {
            this.alert.showAlert("您还没有下注哦!");
            return;
        }
        if ((this.currlDollarType == 40 || this.currlDollarType == 39)) {
            this.checkBetting(this.tempSexCardArr[0]);
        }
        if (this.canBetting) {
            var load = this.loadding.showLoding("订单生成中...");
            var money = this.kqBettingMoney;
            var profileModal;
            if (this.dollarInit.bettingItemData.noteTotal == 0) {
                this.alert.showAlert("您还没有下注哦!");
                this.loadding.closeLoading(load);
                return;
            }
            if (!money && money == 0) {
                this.alert.showAlert("请输入投注金额!");
                this.loadding.closeLoading(load);
                return;
            }
            this.shortcutReset();
            this.getIssue((s) => {
                this.loadding.closeLoading(load);
                this.dollarInit.bettingItemData.IssueNo = s.CurrentIssueNo;
                profileModal = this.modalCtrl.create(BettingListPage, {
                    bettingMoneyCount: this.dollarInit.bettingItemData,
                    bettingMoney: this.kqBettingMoney,
                    bettingNoteHead: this.dollarInit.bettingNoteHead
                }, { cssClass: "modal-inset-min-height-small" }
                );
                profileModal.onDidDismiss(data => {
                    this.reset();
                    this.groupTreeArray = [];
                });
                profileModal.present();
            });
        }

    }

    //配置各快钱玩法重组数据的属性
    fontDollarsAttr(code) {
        switch (code) {
            case 1://双面
                // this.dollarInit.tableHeadName = ["万位", "千位", "百位", "十位", "个位", "总和"];
                this.dollarInit.tableHeadName = ["万位", "千位", "百位", "十位", "个位"];
                if (this.dollarInit.bettingItemData.LotteryCode == "10018") {
                    this.dollarInit.tableHeadName = [
                        "万位",
                        "千位",
                        "百位",
                        "十位",
                        "个位"
                    ];
                }
                this.dollarInit.lumpCount = 6;
                this.dollarInit.lumpSonCount = 6;
                this.dollarInit.tdCount = 6;
                break;
            case 2://数字盘
                this.dollarInit.tableHeadName = ["万位", "千位", "百位", "十位", "个位"];
                this.dollarInit.lumpCount = 5;
                this.dollarInit.lumpSonCount = 10;
                this.dollarInit.tdCount = 10;
                break;
            case 3://一字定位

                this.dollarInit.tableHeadName = ["万定位", "千定位", "百定位", "十定位", "个定位"];
                this.dollarInit.lumpCount = 6;
                this.dollarInit.lumpSonCount = 16;
                this.dollarInit.tdCount = 16;
                break;
            case 4://二字定位
                this.dollarInit.lumpCount = 1;
                this.dollarInit.lumpSonCount = 10;
                this.dollarInit.tdCount = 10;
                this.dollarInit.newDollarsBetting = [
                    {
                        "Label": "万位",
                        "LotteryPlayModeCode": "",
                        "Params": [
                            {
                                "LotteryPlayDetailName": "0"
                            },
                            {
                                "LotteryPlayDetailName": "1"
                            },
                            {
                                "LotteryPlayDetailName": "2"
                            },
                            {
                                "LotteryPlayDetailName": "3"
                            },
                            {
                                "LotteryPlayDetailName": "4"
                            },
                            {
                                "LotteryPlayDetailName": "5"
                            },
                            {
                                "LotteryPlayDetailName": "6"
                            },
                            {
                                "LotteryPlayDetailName": "7"
                            },
                            {
                                "LotteryPlayDetailName": "8"
                            },
                            {
                                "LotteryPlayDetailName": "9"
                            }
                        ]
                    },
                    {
                        "Label": "千位",
                        "LotteryPlayModeCode": "",
                        "Params": [
                            {
                                "LotteryPlayDetailName": "0"
                            },
                            {
                                "LotteryPlayDetailName": "1"
                            },
                            {
                                "LotteryPlayDetailName": "2"
                            },
                            {
                                "LotteryPlayDetailName": "3"
                            },
                            {
                                "LotteryPlayDetailName": "4"
                            },
                            {
                                "LotteryPlayDetailName": "5"
                            },
                            {
                                "LotteryPlayDetailName": "6"
                            },
                            {
                                "LotteryPlayDetailName": "7"
                            },
                            {
                                "LotteryPlayDetailName": "8"
                            },
                            {
                                "LotteryPlayDetailName": "9"
                            }
                        ]
                    },
                    {
                        "Label": "百位",
                        "LotteryPlayModeCode": "",
                        "Params": [
                            {
                                "LotteryPlayDetailName": "0"
                            },
                            {
                                "LotteryPlayDetailName": "1"
                            },
                            {
                                "LotteryPlayDetailName": "2"
                            },
                            {
                                "LotteryPlayDetailName": "3"
                            },
                            {
                                "LotteryPlayDetailName": "4"
                            },
                            {
                                "LotteryPlayDetailName": "5"
                            },
                            {
                                "LotteryPlayDetailName": "6"
                            },
                            {
                                "LotteryPlayDetailName": "7"
                            },
                            {
                                "LotteryPlayDetailName": "8"
                            },
                            {
                                "LotteryPlayDetailName": "9"
                            }
                        ]
                    },
                    {
                        "Label": "十位",
                        "LotteryPlayModeCode": "",
                        "Params": [
                            {
                                "LotteryPlayDetailName": "0"
                            },
                            {
                                "LotteryPlayDetailName": "1"
                            },
                            {
                                "LotteryPlayDetailName": "2"
                            },
                            {
                                "LotteryPlayDetailName": "3"
                            },
                            {
                                "LotteryPlayDetailName": "4"
                            },
                            {
                                "LotteryPlayDetailName": "5"
                            },
                            {
                                "LotteryPlayDetailName": "6"
                            },
                            {
                                "LotteryPlayDetailName": "7"
                            },
                            {
                                "LotteryPlayDetailName": "8"
                            },
                            {
                                "LotteryPlayDetailName": "9"
                            }
                        ]
                    },
                    {
                        "Label": "个位",
                        "LotteryPlayModeCode": "",
                        "Params": [
                            {
                                "LotteryPlayDetailName": "0"
                            },
                            {
                                "LotteryPlayDetailName": "1"
                            },
                            {
                                "LotteryPlayDetailName": "2"
                            },
                            {
                                "LotteryPlayDetailName": "3"
                            },
                            {
                                "LotteryPlayDetailName": "4"
                            },
                            {
                                "LotteryPlayDetailName": "5"
                            },
                            {
                                "LotteryPlayDetailName": "6"
                            },
                            {
                                "LotteryPlayDetailName": "7"
                            },
                            {
                                "LotteryPlayDetailName": "8"
                            },
                            {
                                "LotteryPlayDetailName": "9"
                            }
                        ]
                    }
                ]
                break;
            case 5://三字定位
                this.dollarInit.lumpCount = 1;
                this.dollarInit.lumpSonCount = 10;
                this.dollarInit.tdCount = 10;
                this.dollarInit.newDollarsBetting = [
                    {
                        "Label": "万位",
                        "LotteryPlayModeCode": "",
                        "Params": [
                            {
                                "LotteryPlayDetailName": "0"
                            },
                            {
                                "LotteryPlayDetailName": "1"
                            },
                            {
                                "LotteryPlayDetailName": "2"
                            },
                            {
                                "LotteryPlayDetailName": "3"
                            },
                            {
                                "LotteryPlayDetailName": "4"
                            },
                            {
                                "LotteryPlayDetailName": "5"
                            },
                            {
                                "LotteryPlayDetailName": "6"
                            },
                            {
                                "LotteryPlayDetailName": "7"
                            },
                            {
                                "LotteryPlayDetailName": "8"
                            },
                            {
                                "LotteryPlayDetailName": "9"
                            }
                        ]
                    },
                    {
                        "Label": "千位",
                        "LotteryPlayModeCode": "",
                        "Params": [
                            {
                                "LotteryPlayDetailName": "0"
                            },
                            {
                                "LotteryPlayDetailName": "1"
                            },
                            {
                                "LotteryPlayDetailName": "2"
                            },
                            {
                                "LotteryPlayDetailName": "3"
                            },
                            {
                                "LotteryPlayDetailName": "4"
                            },
                            {
                                "LotteryPlayDetailName": "5"
                            },
                            {
                                "LotteryPlayDetailName": "6"
                            },
                            {
                                "LotteryPlayDetailName": "7"
                            },
                            {
                                "LotteryPlayDetailName": "8"
                            },
                            {
                                "LotteryPlayDetailName": "9"
                            }
                        ]
                    },
                    {
                        "Label": "百位",
                        "LotteryPlayModeCode": "",
                        "Params": [
                            {
                                "LotteryPlayDetailName": "0"
                            },
                            {
                                "LotteryPlayDetailName": "1"
                            },
                            {
                                "LotteryPlayDetailName": "2"
                            },
                            {
                                "LotteryPlayDetailName": "3"
                            },
                            {
                                "LotteryPlayDetailName": "4"
                            },
                            {
                                "LotteryPlayDetailName": "5"
                            },
                            {
                                "LotteryPlayDetailName": "6"
                            },
                            {
                                "LotteryPlayDetailName": "7"
                            },
                            {
                                "LotteryPlayDetailName": "8"
                            },
                            {
                                "LotteryPlayDetailName": "9"
                            }
                        ]
                    },
                    {
                        "Label": "十位",
                        "LotteryPlayModeCode": "",
                        "Params": [
                            {
                                "LotteryPlayDetailName": "0"
                            },
                            {
                                "LotteryPlayDetailName": "1"
                            },
                            {
                                "LotteryPlayDetailName": "2"
                            },
                            {
                                "LotteryPlayDetailName": "3"
                            },
                            {
                                "LotteryPlayDetailName": "4"
                            },
                            {
                                "LotteryPlayDetailName": "5"
                            },
                            {
                                "LotteryPlayDetailName": "6"
                            },
                            {
                                "LotteryPlayDetailName": "7"
                            },
                            {
                                "LotteryPlayDetailName": "8"
                            },
                            {
                                "LotteryPlayDetailName": "9"
                            }
                        ]
                    },
                    {
                        "Label": "个位",
                        "LotteryPlayModeCode": "",
                        "Params": [
                            {
                                "LotteryPlayDetailName": "0"
                            },
                            {
                                "LotteryPlayDetailName": "1"
                            },
                            {
                                "LotteryPlayDetailName": "2"
                            },
                            {
                                "LotteryPlayDetailName": "3"
                            },
                            {
                                "LotteryPlayDetailName": "4"
                            },
                            {
                                "LotteryPlayDetailName": "5"
                            },
                            {
                                "LotteryPlayDetailName": "6"
                            },
                            {
                                "LotteryPlayDetailName": "7"
                            },
                            {
                                "LotteryPlayDetailName": "8"
                            },
                            {
                                "LotteryPlayDetailName": "9"
                            }
                        ]
                    }
                ]
                break;
            case 6://一字组合

                this.dollarInit.tableHeadName = [
                    "全五一字组合",
                    "前三一字组合",
                    "中三一字组合",
                    "后三一字组合"
                ];
                this.dollarInit.bettingNoteHead = ["序号", "位", "号码", "赔率", "金额"];
                this.dollarInit.lumpCount = 4;
                this.dollarInit.lumpSonCount = 10;
                this.dollarInit.tdCount = 10;
                break;
            case 7://二字组合
                this.dollarInit.tdFirstName = ["第一个号", "第二个号"];
                this.dollarInit.bettingNoteHead = ["位", "第一个号", "第二个号", "赔率", "金额"];
                this.dollarInit.lumpCount = 2;
                this.dollarInit.lumpSonCount = 10;
                this.dollarInit.tdCount = 10;
                this.dollarInit.newDollarsBetting = [
                    {
                        "Label": "前三",
                        "LotteryPlayModeCode": "",
                        "Params": [
                            {
                                LotteryPlayDetailName: "0"
                            },
                            {
                                LotteryPlayDetailName: "1"
                            },
                            {
                                LotteryPlayDetailName: "2"
                            },
                            {
                                LotteryPlayDetailName: "3"
                            },
                            {
                                LotteryPlayDetailName: "4"
                            },
                            {
                                LotteryPlayDetailName: "5"
                            },
                            {
                                LotteryPlayDetailName: "6"
                            },
                            {
                                LotteryPlayDetailName: "7"
                            },
                            {
                                LotteryPlayDetailName: "8"
                            },
                            {
                                LotteryPlayDetailName: "9"
                            },
                            {
                                LotteryPlayDetailName: "0"
                            },
                            {
                                LotteryPlayDetailName: "1"
                            },
                            {
                                LotteryPlayDetailName: "2"
                            },
                            {
                                LotteryPlayDetailName: "3"
                            },
                            {
                                LotteryPlayDetailName: "4"
                            },
                            {
                                LotteryPlayDetailName: "5"
                            },
                            {
                                LotteryPlayDetailName: "6"
                            },
                            {
                                LotteryPlayDetailName: "7"
                            },
                            {
                                LotteryPlayDetailName: "8"
                            },
                            {
                                LotteryPlayDetailName: "9"
                            }
                        ]
                    },
                    {
                        "Label": "中三",
                        "LotteryPlayModeCode": "",
                        "Params": [
                            {
                                LotteryPlayDetailName: "0"
                            },
                            {
                                LotteryPlayDetailName: "1"
                            },
                            {
                                LotteryPlayDetailName: "2"
                            },
                            {
                                LotteryPlayDetailName: "3"
                            },
                            {
                                LotteryPlayDetailName: "4"
                            },
                            {
                                LotteryPlayDetailName: "5"
                            },
                            {
                                LotteryPlayDetailName: "6"
                            },
                            {
                                LotteryPlayDetailName: "7"
                            },
                            {
                                LotteryPlayDetailName: "8"
                            },
                            {
                                LotteryPlayDetailName: "9"
                            },
                            {
                                LotteryPlayDetailName: "0"
                            },
                            {
                                LotteryPlayDetailName: "1"
                            },
                            {
                                LotteryPlayDetailName: "2"
                            },
                            {
                                LotteryPlayDetailName: "3"
                            },
                            {
                                LotteryPlayDetailName: "4"
                            },
                            {
                                LotteryPlayDetailName: "5"
                            },
                            {
                                LotteryPlayDetailName: "6"
                            },
                            {
                                LotteryPlayDetailName: "7"
                            },
                            {
                                LotteryPlayDetailName: "8"
                            },
                            {
                                LotteryPlayDetailName: "9"
                            }
                        ]
                    },
                    {
                        "Label": "后三",
                        "LotteryPlayModeCode": "",
                        "Params": [
                            {
                                LotteryPlayDetailName: "0"
                            },
                            {
                                LotteryPlayDetailName: "1"
                            },
                            {
                                LotteryPlayDetailName: "2"
                            },
                            {
                                LotteryPlayDetailName: "3"
                            },
                            {
                                LotteryPlayDetailName: "4"
                            },
                            {
                                LotteryPlayDetailName: "5"
                            },
                            {
                                LotteryPlayDetailName: "6"
                            },
                            {
                                LotteryPlayDetailName: "7"
                            },
                            {
                                LotteryPlayDetailName: "8"
                            },
                            {
                                LotteryPlayDetailName: "9"
                            },
                            {
                                LotteryPlayDetailName: "0"
                            },
                            {
                                LotteryPlayDetailName: "1"
                            },
                            {
                                LotteryPlayDetailName: "2"
                            },
                            {
                                LotteryPlayDetailName: "3"
                            },
                            {
                                LotteryPlayDetailName: "4"
                            },
                            {
                                LotteryPlayDetailName: "5"
                            },
                            {
                                LotteryPlayDetailName: "6"
                            },
                            {
                                LotteryPlayDetailName: "7"
                            },
                            {
                                LotteryPlayDetailName: "8"
                            },
                            {
                                LotteryPlayDetailName: "9"
                            }
                        ]
                    }

                ];
                break;
            case 8://二字和数

                this.dollarInit.tableHeadName = ["和数（单）", "和数（双）"];
                this.dollarInit.bettingNoteHead = ["序号", "单双", "位", "赔率", "金额"];
                this.dollarInit.lumpCount = 2;
                this.dollarInit.lumpSonCount = 10;
                this.dollarInit.tdCount = 2;
                break;
            case 9://组选三
                this.dollarInit.tableHeadName = ["前三", "中三", "后三"];
                this.dollarInit.bettingNoteHead = ["序号", "位", "号码", "赔率", "金额"];
                this.dollarInit.lumpCount = 1;
                this.dollarInit.lumpSonCount = 10;
                this.dollarInit.tdCount = 10;
                this.dollarInit.newDollarsBetting = [
                    {
                        "Label": "前三",
                        "LotteryPlayModeCode": "1124",
                        "Params": [
                            {
                                LotteryPlayDetailName: "0"
                            },
                            {
                                LotteryPlayDetailName: "1"
                            },
                            {
                                LotteryPlayDetailName: "2"
                            },
                            {
                                LotteryPlayDetailName: "3"
                            },
                            {
                                LotteryPlayDetailName: "4"
                            },
                            {
                                LotteryPlayDetailName: "5"
                            },
                            {
                                LotteryPlayDetailName: "6"
                            },
                            {
                                LotteryPlayDetailName: "7"
                            },
                            {
                                LotteryPlayDetailName: "8"
                            },
                            {
                                LotteryPlayDetailName: "9"
                            }
                        ]
                    },
                    {
                        "Label": "中三",
                        "LotteryPlayModeCode": "1125",
                        "Params": [
                            {
                                LotteryPlayDetailName: "0"
                            },
                            {
                                LotteryPlayDetailName: "1"
                            },
                            {
                                LotteryPlayDetailName: "2"
                            },
                            {
                                LotteryPlayDetailName: "3"
                            },
                            {
                                LotteryPlayDetailName: "4"
                            },
                            {
                                LotteryPlayDetailName: "5"
                            },
                            {
                                LotteryPlayDetailName: "6"
                            },
                            {
                                LotteryPlayDetailName: "7"
                            },
                            {
                                LotteryPlayDetailName: "8"
                            },
                            {
                                LotteryPlayDetailName: "9"
                            }
                        ]
                    },
                    {
                        "Label": "后三",
                        "LotteryPlayModeCode": "1126",
                        "Params": [
                            {
                                LotteryPlayDetailName: "0"
                            },
                            {
                                LotteryPlayDetailName: "1"
                            },
                            {
                                LotteryPlayDetailName: "2"
                            },
                            {
                                LotteryPlayDetailName: "3"
                            },
                            {
                                LotteryPlayDetailName: "4"
                            },
                            {
                                LotteryPlayDetailName: "5"
                            },
                            {
                                LotteryPlayDetailName: "6"
                            },
                            {
                                LotteryPlayDetailName: "7"
                            },
                            {
                                LotteryPlayDetailName: "8"
                            },
                            {
                                LotteryPlayDetailName: "9"
                            }
                        ]
                    }

                ];
                break;
            case 10://组选六
                this.dollarInit.tableHeadName = ["前三", "中三", "后三"];
                this.dollarInit.bettingNoteHead = ["序号", "位", "号码", "赔率", "金额"];
                this.dollarInit.lumpCount = 3;
                this.dollarInit.lumpSonCount = 10;
                this.dollarInit.tdCount = 10;
                this.dollarInit.newDollarsBetting = [
                    {
                        "Label": "前三",
                        "LotteryPlayModeCode": "1127",
                        "Params": [
                            {
                                LotteryPlayDetailName: "0"
                            },
                            {
                                LotteryPlayDetailName: "1"
                            },
                            {
                                LotteryPlayDetailName: "2"
                            },
                            {
                                LotteryPlayDetailName: "3"
                            },
                            {
                                LotteryPlayDetailName: "4"
                            },
                            {
                                LotteryPlayDetailName: "5"
                            },
                            {
                                LotteryPlayDetailName: "6"
                            },
                            {
                                LotteryPlayDetailName: "7"
                            },
                            {
                                LotteryPlayDetailName: "8"
                            },
                            {
                                LotteryPlayDetailName: "9"
                            }
                        ]
                    },
                    {
                        "Label": "中三",
                        "LotteryPlayModeCode": "1128",
                        "Params": [
                            {
                                LotteryPlayDetailName: "0"
                            },
                            {
                                LotteryPlayDetailName: "1"
                            },
                            {
                                LotteryPlayDetailName: "2"
                            },
                            {
                                LotteryPlayDetailName: "3"
                            },
                            {
                                LotteryPlayDetailName: "4"
                            },
                            {
                                LotteryPlayDetailName: "5"
                            },
                            {
                                LotteryPlayDetailName: "6"
                            },
                            {
                                LotteryPlayDetailName: "7"
                            },
                            {
                                LotteryPlayDetailName: "8"
                            },
                            {
                                LotteryPlayDetailName: "9"
                            }
                        ]
                    },
                    {
                        "Label": "后三",
                        "LotteryPlayModeCode": "1129",
                        "Params": [
                            {
                                LotteryPlayDetailName: "0"
                            },
                            {
                                LotteryPlayDetailName: "1"
                            },
                            {
                                LotteryPlayDetailName: "2"
                            },
                            {
                                LotteryPlayDetailName: "3"
                            },
                            {
                                LotteryPlayDetailName: "4"
                            },
                            {
                                LotteryPlayDetailName: "5"
                            },
                            {
                                LotteryPlayDetailName: "6"
                            },
                            {
                                LotteryPlayDetailName: "7"
                            },
                            {
                                LotteryPlayDetailName: "8"
                            },
                            {
                                LotteryPlayDetailName: "9"
                            }
                        ]
                    }

                ];
                break;
            case 11://跨度

                this.dollarInit.tableHeadName = ["前三跨度", "中三跨度", "后三跨度"];
                this.dollarInit.lumpCount = 3;
                this.dollarInit.lumpSonCount = 10;
                this.dollarInit.tdCount = 2;
                break;
            case 12://龙虎

                this.dollarInit.tableHeadName = ["万千龙虎", "万百龙虎", "万十龙虎", "万个龙虎", "千百龙虎", "千十龙虎", "千个龙虎", "百十龙虎", "百个龙虎", "十个龙虎"];
                this.dollarInit.tdFirstName = [
                    // {
                    //     nameArry: ["万千龙虎", "万百龙虎", "万十龙虎", "万个龙虎"]
                    // },
                    // {
                    //     nameArry: ["千百龙虎", "千十龙虎", "千个龙虎"]
                    // },
                    // {
                    //     nameArry: ["百十龙虎", "百个龙虎"]
                    // },
                    // {
                    //     nameArry: ["十个龙虎"]
                    // }
                ];
                this.dollarInit.bettingNoteHead = ["序号", "龙虎位", "投注", "赔率", "金额"];
                this.dollarInit.lumpCount = 10;
                this.dollarInit.lumpSonCount = 3;
                this.dollarInit.tdCount = 3;
                break;

            case 13:

                this.dollarInit.tableHeadName = ["大小单双", "大小单双组合", "特殊", "极值", "色波", "和值数字"];
                this.dollarInit.bettingNoteHead = ["和值", "赔率", "金额"];
                this.dollarInit.lumpCount = 3;
                this.dollarInit.lumpSonCount = 28;
                this.dollarInit.tdCount = 4;
                break;
            case 14:

                this.dollarInit.tableHeadName = ["大小单双", "大小单双组合", "特殊", "极值", "色波", "和值数字"];
                this.dollarInit.bettingNoteHead = ["号码", "赔率", "金额"];
                this.dollarInit.lumpCount = 3;
                this.dollarInit.lumpSonCount = 28;
                this.dollarInit.tdCount = 4;
                break;
            case 15:

                this.dollarInit.tableHeadName = ["回本型大小单双", "回本型组合"];
                this.dollarInit.bettingNoteHead = ["号码", "赔率", "金额"];
                this.dollarInit.lumpCount = 2;
                this.dollarInit.lumpSonCount = 4;
                this.dollarInit.tdCount = 4;
                break;
            case 16:

                this.dollarInit.tableHeadName = ["特码", "正码一", "正码二", "正码三", "正码四"];
                this.dollarInit.bettingNoteHead = ["号码", "赔率", "金额"];
                this.dollarInit.lumpCount = 6;
                this.dollarInit.lumpSonCount = 4;
                this.dollarInit.tdCount = 4;
                break;
            case 17:
            case 18:
            case 19:
            case 20:
            case 21:

                this.dollarInit.tableHeadName = ["号码组", "其它组"];
                this.dollarInit.bettingNoteHead = ["号码", "赔率", "金额"];
                this.dollarInit.lumpCount = 2;
                this.dollarInit.lumpSonCount = 11;
                this.dollarInit.tdCount = 4;
                break;
            case 22://快钱龙虎

                this.dollarInit.tableHeadName = ["正一VS正二", "正一VS正三", "正一VS正四", "正一VS特码", "正二VS正三", "正二VS正四", "正二VS特码", "正三VS正四", "正三VS特码", "正四VS特码"];
                this.dollarInit.tdFirstName = ["万", "千", "个", "十"];
                this.dollarInit.bettingNoteHead = ["序号", "龙虎位", "投注", "赔率", "金额"];
                this.dollarInit.lumpCount = 10;
                this.dollarInit.lumpSonCount = 2;
                this.dollarInit.tdCount = 2;
                break;
            case 23:

                this.dollarInit.tableHeadName = ["全5中1"];
                this.dollarInit.bettingNoteHead = ["号码", "赔率", "金额"];
                this.dollarInit.lumpCount = 1;
                this.dollarInit.lumpSonCount = 11;
                this.dollarInit.tdCount = 4;
                break;
            case 24:
            case 25:

                this.dollarInit.tableHeadName = ["冠军", "亚军", "第三名", "第四名", "第五名", "第六名", "第七名", "第八名", "第九名", "第十名"];
                this.dollarInit.bettingNoteHead = ["号码", "赔率", "金额"];
                this.dollarInit.lumpCount = 10;
                this.dollarInit.lumpSonCount = 6;
                this.dollarInit.tdCount = 4;
                break;
            case 26:

                this.dollarInit.tableHeadName = ["和值号码", "大小单双"];
                this.dollarInit.bettingNoteHead = ["号码", "赔率", "金额"];
                this.dollarInit.lumpCount = 10;
                this.dollarInit.lumpSonCount = 6;
                this.dollarInit.tdCount = 4;
                break;
            case 27:

                this.dollarInit.tableHeadName = ["排位号码"];
                this.dollarInit.bettingNoteHead = ["号码", "赔率", "金额"];
                this.dollarInit.lumpCount = 10;
                this.dollarInit.lumpSonCount = 6;
                this.dollarInit.tdCount = 4;
                break;
            case 28:

                this.dollarInit.tableHeadName = ["三军", "全骰、围骰", "短牌", "点数", "长牌"];
                this.dollarInit.bettingNoteHead = ["号码", "赔率", "金额"];
                this.dollarInit.lumpCount = 10;
                this.dollarInit.lumpSonCount = 6;
                this.dollarInit.tdCount = 4;
                break;
            case 29:

                this.dollarInit.tableHeadName = ["第一球", "第二球", "第三球", "前二", "后二"];
                this.dollarInit.bettingNoteHead = ["号码", "赔率", "金额"];
                this.dollarInit.lumpCount = 14;
                this.dollarInit.lumpSonCount = 6;
                this.dollarInit.tdCount = 4;
                break;
            case 30:

                this.dollarInit.tableHeadName = ["特A"];
                this.dollarInit.bettingNoteHead = ["号码", "赔率", "金额"];
                this.dollarInit.lumpCount = 14;
                this.dollarInit.lumpSonCount = 6;
                this.dollarInit.tdCount = 2;
                break;
            case 31:

                this.dollarInit.tableHeadName = ["正码A"];
                this.dollarInit.bettingNoteHead = ["号码", "赔率", "金额"];
                this.dollarInit.lumpCount = 14;
                this.dollarInit.lumpSonCount = 6;
                this.dollarInit.tdCount = 2;
                break;
            case 32:
                //六合彩正特码
                this.dollarInit.tableHeadName = ["正一特", "正二特", "正三特", "正四特", "正五特", "正六特"];
                this.dollarInit.bettingNoteHead = ["序号", "位", "号码", "赔率", "金额"];
                this.dollarInit.lumpCount = 14;
                this.dollarInit.lumpSonCount = 6;
                this.dollarInit.tdCount = 2;
                /* this.dollarInit.newDollarsBetting = [
                    {
                        "Label": "正一特",
                        "LotteryPlayModeCode": "1127",
                        "Params": [
                            {
                                LotteryPlayDetailName: "0"
                            },
                            {
                                LotteryPlayDetailName: "1"
                            },
                            {
                                LotteryPlayDetailName: "2"
                            },
                            {
                                LotteryPlayDetailName: "3"
                            },
                            {
                                LotteryPlayDetailName: "4"
                            },
                            {
                                LotteryPlayDetailName: "5"
                            },
                            {
                                LotteryPlayDetailName: "6"
                            },
                            {
                                LotteryPlayDetailName: "7"
                            },
                            {
                                LotteryPlayDetailName: "8"
                            },
                            {
                                LotteryPlayDetailName: "9"
                            }
                        ]
                    } */
                break;
            case 33:     //六合彩正码1-6

                this.dollarInit.tableHeadName = ["正一码", "正二码", "正三码", "正四码", "正五码", "正六码"];
                this.dollarInit.bettingNoteHead = ["序号", "位", "号码", "赔率", "金额"];
                this.dollarInit.lumpCount = 14;
                this.dollarInit.lumpSonCount = 6;
                this.dollarInit.tdCount = 2;
                break;
            case 34:     //六合彩连码

                this.dollarInit.tableHeadName = ["三全中", "三中二之中二", "二全中", "二中特之中特", "特串", "四中一"];
                this.dollarInit.bettingNoteHead = ["序号", "位", "号码", "赔率", "金额"];
                this.dollarInit.lumpCount = 14;
                this.dollarInit.lumpSonCount = 6;
                this.dollarInit.tdCount = 6;
                break;
            case 35:     //六合彩半波

                this.dollarInit.tableHeadName = ["半波"];
                this.dollarInit.bettingNoteHead = ["序号", "位", "号码", "赔率", "金额"];
                this.dollarInit.lumpCount = 14;
                this.dollarInit.lumpSonCount = 6;
                this.dollarInit.tdCount = 1;
                break;
            case 36:     //六合彩一肖/尾

                this.dollarInit.tableHeadName = ["平特一肖/尾数"];
                this.dollarInit.bettingNoteHead = ["序号", "位", "号码", "赔率", "金额"];
                this.dollarInit.lumpCount = 14;
                this.dollarInit.lumpSonCount = 6;
                this.dollarInit.tdCount = 1;
                break;
            case 37:     //六合彩特肖

                this.dollarInit.tableHeadName = ["特肖"];
                this.dollarInit.bettingNoteHead = ["序号", "位", "号码", "赔率", "金额"];
                this.dollarInit.lumpCount = 14;
                this.dollarInit.lumpSonCount = 6;
                this.dollarInit.tdCount = 1;
                break;
            case 38:     //六合彩合肖

                this.dollarInit.tableHeadName = ["二肖", "三肖", "四肖", "五肖", "六肖", "七肖", "八肖", "九肖", "十肖", "十一肖"];
                this.dollarInit.bettingNoteHead = ["序号", "位", "号码", "赔率", "金额"];
                this.dollarInit.lumpCount = 14;
                this.dollarInit.lumpSonCount = 6;
                this.dollarInit.tdCount = 1;
                break;
            case 39:     //六合彩连肖

                // this.dollarInit.tableHeadName = ["二肖连中", "三肖连中", "四肖连中", "五肖连中", "二肖连不中", "三肖连不中", "四肖连不中",];因赔率过低而取消因的玩法
                this.dollarInit.tableHeadName = ["二肖连中", "三肖连中", "四肖连中", "五肖连中"];
                this.dollarInit.bettingNoteHead = ["序号", "位", "号码", "赔率", "金额"];
                this.dollarInit.lumpCount = 14;
                this.dollarInit.lumpSonCount = 6;
                this.dollarInit.tdCount = 1;
                break;
            case 40:     //六合彩尾数连

                this.dollarInit.tableHeadName = ["二尾连中", "三尾连中", "四尾连中"];
                // this.dollarInit.tableHeadName = ["二尾连中", "三尾连中", "四尾连中", "二尾连不中", "三尾连不中", "四尾连不中"]; 因赔率过低而取消因的玩法
                this.dollarInit.bettingNoteHead = ["序号", "位", "号码", "赔率", "金额"];
                this.dollarInit.lumpCount = 14;
                this.dollarInit.lumpSonCount = 6;
                this.dollarInit.tdCount = 1;
                break;
            case 41:     //六合彩全不中

                this.dollarInit.tableHeadName = ["五不中", "六不中", "七不中", "八不中", "九不中", "十不中", "十一不中", "十二不中"];
                this.dollarInit.bettingNoteHead = ["序号", "位", "号码", "赔率", "金额"];
                this.dollarInit.lumpCount = 14;
                this.dollarInit.lumpSonCount = 6;
                this.dollarInit.tdCount = 6;
                break;
            case 100:     // 七星彩红区
                this.dollarInit.tableHeadName = ["第1位", "第2位", "第3位", "第4位", "第5位", "第6位"];
                this.dollarInit.bettingNoteHead = ["序号", "位", "号码", "赔率", "金额"];
                this.dollarInit.lumpCount = 6;
                this.dollarInit.lumpSonCount = 10;
                this.dollarInit.tdCount = 10;
                break;
            case 101: // 
                this.dollarInit.tableHeadName = this.dollarInit.bettingItemData.LotteryCode == '30016' ? ["蓝区"] : ["红区", "蓝区"];
                this.dollarInit.bettingNoteHead = ["序号", "位", "号码", "赔率", "金额"];
                this.dollarInit.lumpCount = 5;
                this.dollarInit.lumpSonCount = 10;
                this.dollarInit.tdCount = 3;
                break;
            case 102:     // 快乐8
                this.dollarInit.tableHeadName = ["双面"];
                this.dollarInit.bettingNoteHead = ["序号", "位", "号码", "赔率", "金额"];
                this.dollarInit.lumpCount = 5;
                this.dollarInit.lumpSonCount = 80;
                this.dollarInit.tdCount = 3;
                break;
            // case 42:     //棋牌
            //     this.dollarInit.tableHeadName = ["百家乐_庄闲和", "百家乐_庄闲对", "百家乐_大小单双质合", "德州扑克", "牛牛", "斗牛大小单双", "三公_大小单双质合", "三公_左右和"];
            //     this.dollarInit.bettingNoteHead = ["序号", "位", "号码", "赔率", "金额"];
            //     this.dollarInit.lumpCount = 14;
            //     this.dollarInit.lumpSonCount = 4;
            //     this.dollarInit.tdCount = 3;
            //     break;
            // case 43:     //棋牌-百家乐
            //     this.dollarInit.tableHeadName = ["百家乐_庄闲和", "百家乐_庄闲对", "百家乐_大小单双质合"];
            //     this.dollarInit.bettingNoteHead = ["序号", "位", "号码", "赔率", "金额"];
            //     this.dollarInit.lumpCount = 14;
            //     this.dollarInit.lumpSonCount = 4;
            //     this.dollarInit.tdCount = 3;
            //     break;
            // case 44:     //棋牌-牛牛
            //     this.dollarInit.tableHeadName = ["牛牛", "斗牛大小单双"];
            //     this.dollarInit.bettingNoteHead = ["序号", "位", "号码", "赔率", "金额"];
            //     this.dollarInit.lumpCount = 14;
            //     this.dollarInit.lumpSonCount = 4;
            //     this.dollarInit.tdCount = 3;
            //     break;
            // case 45:     //棋牌-德州扑克
            //     this.dollarInit.tableHeadName = ["德州扑克"];
            //     this.dollarInit.bettingNoteHead = ["序号", "位", "号码", "赔率", "金额"];
            //     this.dollarInit.lumpCount = 14;
            //     this.dollarInit.lumpSonCount = 4;
            //     this.dollarInit.tdCount = 3;
            //     break;
            // case 46:     //棋牌-三公
            //     this.dollarInit.tableHeadName = ["三公_大小单双质合", "三公_左右和"];
            //     this.dollarInit.bettingNoteHead = ["序号", "位", "号码", "赔率", "金额"];
            //     this.dollarInit.lumpCount = 14;
            //     this.dollarInit.lumpSonCount = 4;
            //     this.dollarInit.tdCount = 3;
            //     break;
        }
    }

    shortcutClick(shortCutType) {
        if (this.currlDollarType == 13 || this.currlDollarType == 14) {
            let money = this.kqBettingMoney;
            if (this.currlDollarType == 14 && money < 30) {
                this.kqBettingMoney = 30;
            }
            this.clearBetting();
            if (this.dollarInit.newDollarsBetting.length > 0 && this.dollarInit.newDollarsBetting[this.dollarInit.newDollarsBetting.length - 1].Label == "和值数字") {
                let bettingNumbers = this.dollarInit.newDollarsBetting[this.dollarInit.newDollarsBetting.length - 1].newParam;
                if (money && money != 0) {
                    for (let i = 0; i < bettingNumbers.length; i++) {
                        let tr = bettingNumbers[i].tr;  //每行的个数
                        tr.forEach((item, index) => {
                            item.BettingMoney = 0;
                            item.check = false;
                            if (shortCutType === "big" && item.value >= 14) {
                                item.BettingMoney = money;
                                item.check = "true";
                            } else if (shortCutType === "small" && item.value <= 13) {
                                item.BettingMoney = money;
                                item.check = "true";
                            } else if (shortCutType === "single" && item.value % 2 == 1) {
                                item.BettingMoney = money;
                                item.check = "true";
                            } else if (shortCutType === "double" && item.value % 2 == 0) {
                                item.BettingMoney = money;
                                item.check = "true";
                            } else if (shortCutType === "red" && item.color == "red") {
                                item.BettingMoney = money;
                                item.check = "true";
                            } else if (shortCutType === "green" && item.color == "green") {
                                item.BettingMoney = money;
                                item.check = "true";
                            } else if (shortCutType === "blue" && item.color == "blue") {
                                item.BettingMoney = money;
                                item.check = "true";
                            }
                            if (item.check == "true") {
                                this.dollarsBettingList(item, this.dollarInit.newDollarsBetting[0].Label);
                            }
                        })
                    }
                }
            }
        }
    }

    swap(i, j, array) {
        var temp = array[j];
        array[j] = array[i];
        array[i] = temp;
    }

    /**
     * 冒泡排序
     * Evan 2018-04-17
     * @param array 冒泡排序数组
     */
    bubbleSort(array) {
        if (array == undefined || array == null) {
            return;
        }
        let length = array.Params.length, isSwap;
        for (let i = 0; i < length; i++) {            //正序
            isSwap = false;
            for (let j = 0; j < length - 1 - i; j++) {     //正序
                Number(array.Params[j].LotteryPlayDetailName) > Number(array.Params[j + 1].LotteryPlayDetailName) && (isSwap = true) && this.swap(j, j + 1, array.Params);
            }
            if (!isSwap)
                break;
        }
        return array;
    }

    // 获取快钱玩法详细数据并重组
    initDollarsDetaile() {
        let playMode = this.dollarInit.currlottery.PlayMode;
        let count = playMode.PlayDetails.length;
        let lumpCount = this.dollarInit.lumpCount,
            tableHeadName = this.dollarInit.tableHeadName,
            lumpSonCount = this.dollarInit.lumpSonCount;
        if (playMode.LotteryPlayModeTypeCode == 7) {
            playMode.PlayDetails.forEach((s, i) => {
                this.segments[i].value = s.LotteryPlayDetailCode;
                this.segments[i].value = s.LotteryPlayDetailCode;
                this.dollarInit.newDollarsBetting[i].LotteryPlayDetailCode = s.LotteryPlayDetailCode;
            });
            this.dollarInit.newDollarsBetting.forEach(element => {
                element.LotteryPlayModeCode = playMode.LotteryPlayModeCode;
                element.Params.forEach(s => {
                    this.dollarInit.currCardinalMoney = playMode.PlayDetails[0].CardinalMoney1;
                });
            });
            this.openType = this.dollarInit.newDollarsBetting[0].LotteryPlayDetailCode;
            this.dataClone();
            this.recombineDollars();
            return;
        }//二字组合的数据重构

        if (playMode.LotteryPlayModeTypeCode == 4 || playMode.LotteryPlayModeTypeCode == 5) {
            this.dollarInit.newDollarsBetting.forEach(element => {
                element.LotteryPlayModeCode = playMode.LotteryPlayModeCode;
                element.Params.forEach(s => {
                    this.dollarInit.currCardinalMoney = playMode.PlayDetails[0].CardinalMoney1;
                });
            });
            this.dataClone();
            this.recombineDollars();
            return;
        }//二字定位，三字定位的数据重构
        //组选三和组选6的数据重构
        if (playMode.LotteryPlayModeTypeCode == 9 || playMode.LotteryPlayModeTypeCode == 10) {
            this.dollarInit.groupAttr = this.groupBy.transform(playMode.PlayDetails, "AlgorithmCode");
            let codeAttr = [];
            for (var c in this.dollarInit.groupAttr) {
                codeAttr.push(c);
            }
            this.dollarInit.newDollarsBetting.forEach((s, i) => {
                s.AlgorithmCode = codeAttr[i];
                this.segments[i].value = s.LotteryPlayModeCode;
                this.dollarInit.newDollarsBetting[i].LotteryPlayDetailCode = s.LotteryPlayModeCode;
            });
            this.dollarInit.cardinalMoneyArry = []; //赔率随所选数字数量而变化，对应数量5，6，7，8，9，10
            let code = this.dollarInit.newDollarsBetting[0].AlgorithmCode;
            this.dollarInit.groupAttr[code].forEach(s => { this.dollarInit.cardinalMoneyArry.push(s.CardinalMoney1); });
            this.openType = this.dollarInit.newDollarsBetting[0].LotteryPlayModeCode;
            this.dataClone();
            this.recombineDollars();
            return;
        }

        if ((playMode.LotteryPlayModeTypeCode >= 1 && playMode.LotteryPlayModeTypeCode <= 4) ||
            playMode.LotteryPlayModeTypeCode == 6 || playMode.LotteryPlayModeTypeCode == 8 ||
            playMode.LotteryPlayModeTypeCode == 11 || playMode.LotteryPlayModeTypeCode == 13 ||
            (playMode.LotteryPlayModeTypeCode >= 14 && playMode.LotteryPlayModeTypeCode <= 21) ||
            (playMode.LotteryPlayModeTypeCode >= 23 && playMode.LotteryPlayModeTypeCode <= 29) ||
            (playMode.LotteryPlayModeTypeCode >= 30 && playMode.LotteryPlayModeTypeCode <= 41) || playMode.LotteryPlayModeTypeCode == 100 || 
            playMode.LotteryPlayModeTypeCode == 101 || playMode.LotteryPlayModeTypeCode == 102

            // || (playMode.LotteryPlayModeTypeCode >= 42 && playMode.LotteryPlayModeTypeCode <= 46
            //     )
        ) {
            for (var i = 0; i < tableHeadName.length; i++) {
                let that = this,
                    dollarLumpAttr = {
                        Label: tableHeadName[i],
                        LotteryPlayModeCode: playMode.LotteryPlayModeCode,
                        Params: []
                    };
                this.dollarInit.newDollarsBetting.push(dollarLumpAttr);
                // playMode.PlayDetails.filter((value, index) => {
                playMode.PlayDetails.sort((a, b) => { return a.SerialsID - b.SerialsID }).filter((value, index) => {
                    if (playMode.LotteryPlayModeTypeCode == 34 || playMode.LotteryPlayModeTypeCode == 41) {
                        let year = AppConfig.markSixYear || new Date().getFullYear();
                        let k = 1;
                        for (var m = year; m >= (year - 48); m--) {
                            let attr = new DollerAttr();
                            attr.LotteryPlayDetailName = k + "";
                            attr.currLotteryPlayDetailName = value.LotteryPlayDetailName;;
                            attr.LotteryPlayDetailCode = value.LotteryPlayDetailCode;
                            attr.Modulus = value.Modulus;
                            attr.CardinalMoney = value.CardinalMoney;
                            let zodiacAndPoultry = this.bettinghelper.getZodiacAndPoultryByYean(m);
                            attr.extendValue = {
                                zodiac: zodiacAndPoultry.zodiac,
                                isPoultry: zodiacAndPoultry.isPoultry
                            }
                            if (value.CardinalMoney1) {
                                attr.BettingOdds = value.CardinalMoney1;
                            }
                            if (tableHeadName[i] == value.PlayGroup) {
                                that.dollarInit.newDollarsBetting[i].Params.push(attr);
                            }
                            k += 1;
                        }
                    } else if (playMode.LotteryPlayModeTypeCode == 38) {
                        this.zodiacArr.forEach((zodiac, index) => {
                            let attr = new DollerAttr();
                            attr.LotteryPlayDetailName = zodiac;
                            attr.currLotteryPlayDetailName = value.LotteryPlayDetailName;
                            attr.LotteryPlayDetailCode = value.LotteryPlayDetailCode;
                            attr.Modulus = value.Modulus;
                            attr.CardinalMoney = value.CardinalMoney;
                            if (value.CardinalMoney1) {
                                attr.BettingOdds = value.CardinalMoney1;
                            }
                            if (tableHeadName[i] == value.PlayGroup) {
                                that.dollarInit.newDollarsBetting[i].Params.push(attr);
                            }
                        });
                    } else if (playMode.LotteryPlayModeTypeCode == 40) {
                        // let numberArr = ["1", "2", "3", "4", "5", "6", "7", "8", "9", "0"];
                        let numberArr = ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9"];
                        let count = 0;
                        numberArr.forEach((number) => {
                            let attr = new DollerAttr();
                            attr.LotteryPlayDetailName = number;
                            // attr.currLotteryPlayDetailName = value.LotteryPlayDetailName;
                            attr.currLotteryPlayDetailName = tableHeadName[i];
                            attr.LotteryPlayDetailCode = value.LotteryPlayDetailCode;
                            attr.Modulus = value.Modulus;
                            attr.CardinalMoney = value.CardinalMoney;
                            if (value.CardinalMoney1) {
                                attr.BettingOdds = value.CardinalMoney1;
                            }
                            if (tableHeadName[i] == value.PlayGroup && count.toString() == index.toString().substr(index.toString().length - 1)) {
                                that.dollarInit.newDollarsBetting[i].Params.push(attr);
                            }
                            count++;
                        });
                    } else if (playMode.LotteryPlayModeTypeCode == 39) {
                        let attr = new DollerAttr();
                        attr.LotteryPlayDetailName = value.LotteryPlayDetailName;
                        attr.currLotteryPlayDetailName = value.PlayGroup;
                        attr.LotteryPlayDetailCode = value.LotteryPlayDetailCode;
                        attr.Modulus = value.Modulus;
                        attr.CardinalMoney = value.CardinalMoney;
                        if (value.CardinalMoney1) {
                            attr.BettingOdds = value.CardinalMoney1;
                        }
                        if (tableHeadName[i] == value.PlayGroup) {
                            that.dollarInit.newDollarsBetting[i].Params.push(attr);
                        }
                    } else {
                        let attr = new DollerAttr();
                        attr.LotteryPlayDetailName = value.LotteryPlayDetailName;
                        attr.LotteryPlayDetailCode = value.LotteryPlayDetailCode;
                        attr.Modulus = value.Modulus;
                        attr.CardinalMoney = value.CardinalMoney;
                        if (value.CardinalMoney1) {
                            attr.BettingOdds = value.CardinalMoney1;
                        }
                        if (tableHeadName[i] == value.PlayGroup) {
                            that.dollarInit.newDollarsBetting[i].Params.push(attr);
                        }
                    }
                });
            }
            if ((playMode.LotteryPlayModeTypeCode >= 32 && playMode.LotteryPlayModeTypeCode <= 34) ||
                (playMode.LotteryPlayModeTypeCode >= 38 && playMode.LotteryPlayModeTypeCode <= 41) ||
                (playMode.LotteryPlayModeTypeCode >= 42 && playMode.LotteryPlayModeTypeCode <= 44) ||
                playMode.LotteryPlayModeTypeCode == 46 
            ) {
                this.segments = [];
                this.dollarInit.newDollarsBetting.forEach((element) => {
                    this.segments.push({
                        value: element.Label,
                        name: element.Label
                    });
                });
            }
            if (playMode.LotteryPlayModeTypeCode == 13 || playMode.LotteryPlayModeTypeCode == 14) {
                this.bubbleSort(this.dollarInit.newDollarsBetting[0]);
            }
            this.openType = this.dollarInit.newDollarsBetting[0].Label;
            this.dataClone();
            this.recombineDollars();
            return;
        }


        if (playMode.LotteryPlayModeTypeCode == 12 || playMode.LotteryPlayModeTypeCode == 22) {
            this.dollarInit.tableHeadName.forEach((item, i) => {
                let that = this,
                    dollarLumpAttr = {
                        Label: tableHeadName[i],
                        LotteryPlayModeCode: playMode.LotteryPlayModeCode,
                        Params: []
                    };
                this.dollarInit.newDollarsBetting.push(dollarLumpAttr);
                // item.nameArry.forEach((name, j) => {
                playMode.PlayDetails.filter((value, m) => {
                    let attr = new DollerAttr();
                    attr.LotteryPlayDetailName = value.LotteryPlayDetailName;
                    attr.LotteryPlayDetailCode = value.LotteryPlayDetailCode;
                    attr.Modulus = value.Modulus;
                    attr.CardinalMoney = value.CardinalMoney;
                    if (value.CardinalMoney1) {
                        attr.BettingOdds = value.CardinalMoney1;
                    }
                    if (item == value.PlayGroup) {
                        that.dollarInit.newDollarsBetting[i].Params.push(attr);
                    }
                });
                // });
            });
            this.dataClone();
            this.recombineDollars();
            return;
        }

        if ((playMode.LotteryPlayModeTypeCode >= 1 && playMode.LotteryPlayModeTypeCode <= 4) ||
            playMode.LotteryPlayModeTypeCode == 6 || playMode.LotteryPlayModeTypeCode == 8 ||
            playMode.LotteryPlayModeTypeCode == 11 || playMode.LotteryPlayModeTypeCode == 13 ||
            (playMode.LotteryPlayModeTypeCode >= 14 && playMode.LotteryPlayModeTypeCode <= 21) ||
            (playMode.LotteryPlayModeTypeCode >= 23 && playMode.LotteryPlayModeTypeCode <= 29)) {
            for (var i = 0; i < tableHeadName.length; i++) {
                let that = this,
                    dollarLumpAttr = {
                        Label: tableHeadName[i],
                        LotteryPlayModeCode: playMode.LotteryPlayModeCode,
                        Params: []
                    };
                this.dollarInit.newDollarsBetting.push(dollarLumpAttr);
                playMode.PlayDetails.filter((value, index) => {
                    let attr = new DollerAttr();
                    attr.LotteryPlayDetailName = value.LotteryPlayDetailName;
                    attr.LotteryPlayDetailCode = value.LotteryPlayDetailCode;
                    attr.Modulus = value.Modulus;
                    attr.CardinalMoney = value.CardinalMoney;
                    if (value.CardinalMoney1) {
                        attr.BettingOdds = value.CardinalMoney1;
                    }
                    if (tableHeadName[i] == value.PlayGroup) {
                        that.dollarInit.newDollarsBetting[i].Params.push(attr);
                    }
                    else {
                        if (tableHeadName[i].indexOf('色波') >= 0 || tableHeadName[i].indexOf('豹子') >= 0) {
                            if (value.PlayGroup == "色波" || attr.LotteryPlayDetailName.indexOf('豹子') >= 0)
                                that.dollarInit.newDollarsBetting[i].Params.push(attr);
                        }
                    }
                });
            }
            if (playMode.LotteryPlayModeTypeCode == 13 || playMode.LotteryPlayModeTypeCode == 14) {
                this.bubbleSort(this.dollarInit.newDollarsBetting[0]);
            }
            this.dataClone();
            this.recombineDollars();
            return;
        }

        // var x = 0, //计算基数
        //     y = 0; //计算基数
        // for (var i = 0; i < lumpCount; i++) {
        //     var radix = [4, 3, 2, 1];//龙虎数据计算基数
        //     var radix2 = [0, 4, 3, 2];//龙虎数据计算基数
        //     if (playMode.LotteryPlayModeTypeCode == 13) {
        //         x = x + (radix2[i] * 3);
        //         y = y + (radix[i] * 3);
        //     }//龙虎玩法数据处理
        //     else {
        //         x = i * this.dollarInit.lumpSonCount;
        //         y = this.dollarInit.lumpSonCount * (i + 1);
        //     }
        //     let dollarLumpAttr = {
        //         Label: "",
        //         LotteryPlayModeCode: "",
        //         Params: []
        //     };//快钱玩法数据结构重构
        //     if (tableHeadName && tableHeadName.length != 0) {
        //         dollarLumpAttr.Label = tableHeadName[i];
        //     }
        //     dollarLumpAttr.LotteryPlayModeCode = playMode.LotteryPlayModeCode;
        //     this.dollarInit.newDollarsBetting.push(dollarLumpAttr);
        //     for (var j = x; j < y && j < count; j++) {
        //         let attr = new DollerAttr();
        //         attr.LotteryPlayDetailName = playMode.PlayDetails[j].LotteryPlayDetailName;
        //         attr.LotteryPlayDetailCode = playMode.PlayDetails[j].LotteryPlayDetailCode;
        //         attr.Modulus = playMode.PlayDetails[j].Modulus;
        //         attr.CardinalMoney = playMode.PlayDetails[j].CardinalMoney;
        //         if (playMode.PlayDetails[j].CardinalMoney1) {
        //             attr.BettingOdds = playMode.PlayDetails[j].CardinalMoney1;
        //         }
        //         this.dollarInit.newDollarsBetting[i].Params.push(attr);
        //     }
        // }
        // if (count > lumpCount * lumpSonCount) {
        //     for (var j = lumpCount * lumpSonCount; j < count; j++) {
        //         let attr = new DollerAttr();
        //         attr.LotteryPlayDetailName = playMode.PlayDetails[j].LotteryPlayDetailName;
        //         attr.LotteryPlayDetailCode = playMode.PlayDetails[j].LotteryPlayDetailCode;
        //         attr.Modulus = playMode.PlayDetails[j].Modulus;
        //         attr.CardinalMoney = playMode.PlayDetails[j].CardinalMoney;
        //         attr.BettingOdds = playMode.PlayDetails[j].CardinalMoney1;
        //         // if(this.currlDollarType == 3){
        //         //     this.dollarInit.newDollarsBetting[0].Params.push(attr);
        //         // }//一字定位特殊对待多余部分数据加入到第一栏位置中
        //         // else{
        //         this.dollarInit.newDollarsBetting[lumpCount - 1].Params.push(attr);
        //         // }//多余部分数据加入到最后一栏位置中
        //     }
        // }

    }

    /**
     * 切割棋牌游戏
     */
    detachmentQipai() {
        let baijiale: any = {};
        let baijialeGame: any = [];
        let douniu: any = {};
        let douniuGame: any = [];
        let dezhoupuke: any = {};
        let dezhoupukeGame: any = [];
        let sangong: any = {};
        let sangongGame: any = [];
        this.playDollarModes.PlayModes.forEach(v => {
            if (v.LotteryPlayModeName == "棋牌") {
                v.PlayDetails.forEach(element => {
                    let gameName = element.PlayGroup;
                    if (gameName.substr(0, 2) == '百家') {
                        baijiale = Object.assign({}, v);//浅拷贝
                        baijialeGame.push(element);
                    }
                    baijiale.PlayDetails = baijialeGame;
                    baijiale.LotteryPlayModeName = "百家乐";
                });
            }
            if (v.LotteryPlayModeName == "棋牌") {
                v.PlayDetails.forEach(element => {
                    let gameName = element.PlayGroup;
                    if (gameName.substr(0, 2) == '斗牛') {
                        douniu = Object.assign({}, v);
                        douniuGame.push(element);
                    }
                    douniu.PlayDetails = douniuGame;
                    douniu.LotteryPlayModeName = "斗牛";
                });
            }
            if (v.LotteryPlayModeName == "棋牌") {
                v.PlayDetails.forEach(element => {
                    let gameName = element.PlayGroup;
                    if (gameName.substr(0, 2) == '德州') {
                        dezhoupuke = Object.assign({}, v);
                        dezhoupukeGame.push(element);
                    }
                    dezhoupuke.PlayDetails = dezhoupukeGame;
                    dezhoupuke.LotteryPlayModeName = "德州扑克";
                });
            }
            if (v.LotteryPlayModeName == "棋牌") {
                v.PlayDetails.forEach(element => {
                    let gameName = element.PlayGroup;
                    if (gameName.substr(0, 2) == '三公') {
                        sangong = Object.assign({}, v);
                        sangongGame.push(element);
                    }
                    sangong.PlayDetails = sangongGame;
                    sangong.LotteryPlayModeName = "三公";
                });
            }
        })
        this.playDollarModes.PlayModes.splice((this.playDollarModes.PlayModes.length - 1), 1, baijiale, douniu, dezhoupuke, sangong);
    }

    markSixCardinalMoney(bettingDetial) {
        let index = this.tempSexCardArr.findIndex((item) => {
            return item.LotteryPlayDetailCode == bettingDetial.LotteryPlayDetailCode
                && item.LotteryPlayDetailName == bettingDetial.LotteryPlayDetailName
        });
        if (index == -1)
            this.tempSexCardArr.push(bettingDetial);
        else
            this.tempSexCardArr.splice(index, 1);
        let tempBet = bettingDetial;
        if (tempBet.currLotteryPlayDetailName == "二全中" || tempBet.currLotteryPlayDetailName == "二中特之中特"
            || tempBet.currLotteryPlayDetailName == "特串" || tempBet.currLotteryPlayDetailName == "二肖"
            || tempBet.currLotteryPlayDetailName.indexOf("二尾") > -1 || tempBet.currLotteryPlayDetailName == "二肖连中") {
            if (this.tempSexCardArr.length >= 2)
                this.markSixCardinal = bettingDetial.BettingOdds;
            else {
                this.clearBetting()
                this.markSixCardinal = 0

            }
        } else if (tempBet.currLotteryPlayDetailName == "三全中" || tempBet.currLotteryPlayDetailName == "三中二之中二"
            || tempBet.currLotteryPlayDetailName == "三肖" || tempBet.currLotteryPlayDetailName.indexOf("三尾") > -1
            || tempBet.currLotteryPlayDetailName == "三肖连中") {
            if (this.tempSexCardArr.length >= 3)
                this.markSixCardinal = bettingDetial.BettingOdds;
            else {
                this.clearBetting()
                this.markSixCardinal = 0
            }
        } else if (tempBet.currLotteryPlayDetailName == "四中一" || tempBet.currLotteryPlayDetailName == "四肖"
            || tempBet.currLotteryPlayDetailName.indexOf("四尾") > -1 || tempBet.currLotteryPlayDetailName == "四肖连中") {
            if (this.tempSexCardArr.length >= 4)
                this.markSixCardinal = bettingDetial.BettingOdds;
            else {
                this.clearBetting()
                this.markSixCardinal = 0
            }
        } else if (tempBet.currLotteryPlayDetailName == "五肖" || tempBet.currLotteryPlayDetailName == "五不中") {
            if (this.tempSexCardArr.length >= 5 || tempBet.currLotteryPlayDetailName == "五肖连中")
                this.markSixCardinal = bettingDetial.BettingOdds;
            else {
                this.clearBetting()
                this.markSixCardinal = 0
            }
        } else if (tempBet.currLotteryPlayDetailName == "六肖" || tempBet.currLotteryPlayDetailName == "六不中") {
            if (this.tempSexCardArr.length >= 6)
                this.markSixCardinal = bettingDetial.BettingOdds;
            else {
                this.clearBetting()
                this.markSixCardinal = 0
            }
        } else if (tempBet.currLotteryPlayDetailName == "七肖" || tempBet.currLotteryPlayDetailName == "七不中") {
            if (this.tempSexCardArr.length >= 7)
                this.markSixCardinal = bettingDetial.BettingOdds;
            else {
                this.clearBetting()
                this.markSixCardinal = 0
            }
        } else if (tempBet.currLotteryPlayDetailName == "八肖" || tempBet.currLotteryPlayDetailName == "八不中") {
            if (this.tempSexCardArr.length >= 8)
                this.markSixCardinal = bettingDetial.BettingOdds;
            else {
                this.clearBetting()
                this.markSixCardinal = 0
            }
        } else if (tempBet.currLotteryPlayDetailName == "九肖" || tempBet.currLotteryPlayDetailName == "九不中") {
            if (this.tempSexCardArr.length >= 9)
                this.markSixCardinal = bettingDetial.BettingOdds;
            else {
                this.clearBetting()
                this.markSixCardinal = 0
            }
        } else if (tempBet.currLotteryPlayDetailName == "十肖" || tempBet.currLotteryPlayDetailName == "十不中") {
            if (this.tempSexCardArr.length >= 10)
                this.markSixCardinal = bettingDetial.BettingOdds;
            else {
                this.clearBetting()
                this.markSixCardinal = 0
            }
        } else if (tempBet.currLotteryPlayDetailName == "十一肖" || tempBet.currLotteryPlayDetailName == "十一不中") {
            if (this.tempSexCardArr.length >= 11)
                this.markSixCardinal = bettingDetial.BettingOdds;
            else {
                this.clearBetting()
                this.markSixCardinal = 0
            }
        } else if (tempBet.currLotteryPlayDetailName == "十二不中") {
            if (this.tempSexCardArr.length >= 12)
                this.markSixCardinal = bettingDetial.BettingOdds;
            else {
                this.clearBetting()
                this.markSixCardinal = 0
            }
        }

    }


    /**
     * 六合彩连码34，合肖38，连肖39 尾数连40，全不中41玩法提交
     * evan 2018-07-12
     * @memberof LotteryComponent
     */
    LetteryMarkSixChoice() {
        if (this.tempSexCardArr.length > 0) {
            this.dollarInit.currBonus = this.dollarInit.BonusMode[0] * 10;
            var money = this.kqBettingMoney;
            let betItemList = [];
            let tempBet = this.tempSexCardArr[0];
            let combine_n = 0;
            if (tempBet.currLotteryPlayDetailName == "二全中" || tempBet.currLotteryPlayDetailName == "二中特之中特" ||
                tempBet.currLotteryPlayDetailName == "特串" || tempBet.currLotteryPlayDetailName == "二肖" || tempBet.currLotteryPlayDetailName == "二肖连中"
                || tempBet.currLotteryPlayDetailName.indexOf("二尾") > -1) {
                if (this.tempSexCardArr.length < 2) {
                    // this.alert.showAlert("请在" + tempBet.currLotteryPlayDetailName + "中选择2个以上号码进行投注！");
                    return;
                } else {
                    combine_n = 2;
                }
            } else if (tempBet.currLotteryPlayDetailName == "三全中" || tempBet.currLotteryPlayDetailName == "三中二之中二"
                || tempBet.currLotteryPlayDetailName == "三肖" || tempBet.currLotteryPlayDetailName.indexOf("三尾") > -1
                || tempBet.currLotteryPlayDetailName == "三肖连中") {
                if (this.tempSexCardArr.length < 3) {
                    // this.alert.showAlert("请在" + tempBet.currLotteryPlayDetailName + "中选择3个以上号码进行投注！");
                    return;
                } else {
                    combine_n = 3;
                }
            } else if (tempBet.currLotteryPlayDetailName == "四中一" || tempBet.currLotteryPlayDetailName == "四肖"
                || tempBet.currLotteryPlayDetailName.indexOf("四尾") > -1 || tempBet.currLotteryPlayDetailName == "四肖连中") {
                if (this.tempSexCardArr.length < 4) {
                    // this.alert.showAlert("请在" + tempBet.currLotteryPlayDetailName + "中选择4个以上号码进行投注！");
                    return;
                } else {
                    combine_n = 4;
                }
            } else if (tempBet.currLotteryPlayDetailName == "五肖" || tempBet.currLotteryPlayDetailName == "五不中"
                || tempBet.currLotteryPlayDetailName == "五肖连中") {
                if (this.tempSexCardArr.length < 5) {
                    // this.alert.showAlert("请在" + tempBet.currLotteryPlayDetailName + "中选择5个以上号码进行投注！");
                    return;
                } else {
                    combine_n = 5;
                }
            } else if (tempBet.currLotteryPlayDetailName == "六肖" || tempBet.currLotteryPlayDetailName == "六不中") {
                if (this.tempSexCardArr.length < 6) {
                    // this.alert.showAlert("请在" + tempBet.currLotteryPlayDetailName + "中选择6个以上号码进行投注！");
                    return;
                } else {
                    combine_n = 6;
                }
            } else if (tempBet.currLotteryPlayDetailName == "七肖" || tempBet.currLotteryPlayDetailName == "七不中") {
                if (this.tempSexCardArr.length < 7) {
                    // this.alert.showAlert("请在" + tempBet.currLotteryPlayDetailName + "中选择7个以上号码进行投注！");
                    return;
                } else {
                    combine_n = 7;
                }
            } else if (tempBet.currLotteryPlayDetailName == "八肖" || tempBet.currLotteryPlayDetailName == "八不中") {
                if (this.tempSexCardArr.length < 8) {
                    // this.alert.showAlert("请在" + tempBet.currLotteryPlayDetailName + "中选择8个以上号码进行投注！");
                    return;
                } else {
                    combine_n = 8;
                }
            } else if (tempBet.currLotteryPlayDetailName == "九肖" || tempBet.currLotteryPlayDetailName == "九不中") {
                if (this.tempSexCardArr.length < 9) {
                    // this.alert.showAlert("请在" + tempBet.currLotteryPlayDetailName + "中选择9个以上号码进行投注！");
                    return;
                } else {
                    combine_n = 9;
                }
            } else if (tempBet.currLotteryPlayDetailName == "十肖" || tempBet.currLotteryPlayDetailName == "十不中") {
                if (this.tempSexCardArr.length < 10) {
                    // this.alert.showAlert("请在" + tempBet.currLotteryPlayDetailName + "中选择10个以上号码进行投注！");
                    return;
                } else {
                    combine_n = 10;
                }
            } else if (tempBet.currLotteryPlayDetailName == "十一肖" || tempBet.currLotteryPlayDetailName == "十一不中") {
                if (this.tempSexCardArr.length < 11) {
                    // this.alert.showAlert("请在" + tempBet.currLotteryPlayDetailName + "中选择11个以上号码进行投注！");
                    return;
                } else {
                    combine_n = 11;
                }
            } else if (tempBet.currLotteryPlayDetailName == "十二不中") {
                if (this.tempSexCardArr.length < 12) {
                    // this.alert.showAlert("请在" + tempBet.currLotteryPlayDetailName + "中选择12个以上号码进行投注！");
                    return;
                } else {
                    combine_n = 12;
                }
            }
            if (combine_n != 0) {
                betItemList = this.arrayCombine(this.tempSexCardArr, combine_n);
                if (betItemList.length > 0) {
                    this.dollarInit.bettingItemData.BettingItemList = [];
                    betItemList.forEach((combineStr, index) => {
                        let bet = new AnBetting();
                        bet.SerialNo = index + 1;
                        if (this.dollarInit.currlottery.PlayMode.LotteryPlayModeTypeCode == 39
                            || this.dollarInit.currlottery.PlayMode.LotteryPlayModeTypeCode == 38) {
                            bet.BettingNumber = this.getZodiacArrIndex(combineStr.betZodiacs);
                            let tempOdds = combineStr.betOdds.sort((a, b) => { return a - b });
                            this.markSixCardinal = tempOdds[0];
                        } else if (this.dollarInit.currlottery.PlayMode.LotteryPlayModeTypeCode == 40) {
                            let tempOdds = combineStr.betOdds.sort((a, b) => { return a - b });
                            this.markSixCardinal = tempOdds[tempOdds.length - 1];
                            bet.BettingNumber = combineStr.betZodiacs;
                        }
                        else {
                            bet.BettingNumber = combineStr.betZodiacs;
                        }
                        bet.BettingOdds = this.markSixCardinal;
                        bet.Position2 = tempBet.currLotteryPlayDetailName;
                        bet.Position = tempBet.currLotteryPlayDetailName;
                        bet.Position3 = combineStr.betZodiacs;
                        bet.BettingMoney = money;
                        bet.RangeValue = this.dollarInit.rangeValue;
                        bet.Rebate = this.dollarInit.currBonus;
                        bet.LotteryPlayDetailCode = tempBet.LotteryPlayDetailCode;

                        // bet.currLotteryPlayDetailName: string;
                        this.dollarInit.bettingItemData.BettingItemList.push(bet);
                    })
                }
                this.dollarsBettingTotal();
                // this.tempSexCardArr = [];
                this.markSixCardinal = 0;
                this.getBettingItemString();
            }
        }
    }

    getZodiacArrIndex(zodiacName) {
        let indexArr = "";
        zodiacName.split(',').forEach((v, i) => {
            let index = this.zodiacArr.findIndex((zodiac) => {
                return v == zodiac;
            });
            if (index != -1) {
                indexArr += "," + index;
            }
        });
        indexArr = indexArr.substr(1, indexArr.length);
        if (indexArr.trim().length == 0) {
            this.alert.errorAlert("选号有误，请重新选择号码!");
            return;
        }
        return indexArr;
    }


    /**
    * 获得从m中取n的所有组合
    *
    * @param {*} targetArr
    * @returns
    * @memberof LotteryComponent
    */
    arrayCombine(targetArr, n) {
        let resultArrs = [],
            b = [],
            strBuffer = "",
            bettingOdds = "";
        for (let i = 0; i < targetArr.length; i++) {
            if (i < n) {
                b[i] = "1";
            } else {
                b[i] = "0";
            }
        }
        let point = 0;
        let nextPoint = 0;
        let count = 0;
        let sum = 0;
        let temp = "1";

        while (true) {
            // 判断是否全部移位完毕
            for (let i = b.length - 1; i >= b.length - n; i--) {
                if (b[i] === "1")
                    sum += 1;
            }
            // 根据移位生成数据
            for (let i = 0; i < targetArr.length; i++) {
                if (b[i] === "1") {
                    point = i;
                    strBuffer += "," + targetArr[point].LotteryPlayDetailName;
                    bettingOdds += "," + targetArr[point].BettingOdds;
                    count++;
                    if (count == n)
                        break;
                }
            }
            // 往返回值列表添加数据
            resultArrs.push({ betZodiacs: strBuffer.substring(1, strBuffer.length), betOdds: bettingOdds.substring(1, bettingOdds.length), });
            if (sum == n) {
                break;
            }

            sum = 0;
            // 修改从左往右第一个10变成01
            for (let i = 0; i < b.length - 1; i++) {
                if (b[i] === "1" && b[i + 1] === "0") {
                    point = i;
                    nextPoint = i + 1;
                    b[point] = "0";
                    b[nextPoint] = "1";
                    break;
                }
            }
            // 将 i-point个元素的1往前移动 0往后移动
            for (let i = 0; i < point - 1; i++) {
                for (let j = i; j < point - 1; j++) {
                    if (b[i] === "0") {
                        temp = b[i];
                        b[i] = b[j + 1];
                        b[j + 1] = temp;
                    }
                }
            }
            // 清空 StringBuffer
            strBuffer = "";
            bettingOdds = "";
            count = 0;
        }
        if (resultArrs.length > 0) {
            resultArrs.forEach((item) => {
                let temp = [];
                item.betOdds.split(",").forEach(value => {
                    temp.push(parseFloat(value));
                })
                item.betOdds = temp;
            })
        }
        return resultArrs;
    }

    //深度克隆双面盘数据
    dataClone() {
        this.dollarInit.newDollarsBettingClone = JSON.parse(JSON.stringify(this.dollarInit.newDollarsBetting));
    }

    getNumColor(num) {
        var color = "gray";
        if (num != 0 && num != 27 && num != 13 && num != 14) {
            if (num % 3 == 0) {
                color = "red";
            } else if (num % 3 == 1) {
                color = "green";
            } else if (num % 3 == 2) {
                color = "blue";
            }
        }
        return color;
    }
    //重组快钱玩法投注类型数据,n:行单位数
    recombineDollars() {
        this.isOne++;
        let playMode = this.dollarInit.currlottery.PlayMode;
        let n = this.dollarInit.tdCount == 0 ? 10 : this.dollarInit.tdCount;
        this.dollarInit.newDollarsBetting.forEach((s, event) => {
            let count = s['Params'].length;
            let trCount = Math.ceil(count / n);
            s.newParam = [];
            s.Params.forEach(r => {
                r.BettingMoney = 0;
                r.check = false;
                if (!isNaN(r.LotteryPlayDetailName) && playMode.LotteryPlayModeTypeCode != 40) {
                    r.value = parseInt(r.LotteryPlayDetailName);
                    if (playMode.LotteryPlayModeTypeCode >= 13 && playMode.LotteryPlayModeTypeCode <= 15) {
                        r.color = this.getNumColor(r.value); // PC蛋蛋
                    }
                    else if (playMode.LotteryPlayModeTypeCode >= 30 && playMode.LotteryPlayModeTypeCode !== 100 &&
                        playMode.LotteryPlayModeTypeCode !== 101 && playMode.LotteryPlayModeTypeCode !== 102) {
                        let markSixNumberModel = this.bettinghelper.getLetteryMarkSixColor(r.value);
                        r.color = markSixNumberModel.color;        // 颜色
                        if (r.extendValue) {
                            r.zodiac = r.extendValue.zodiac;      // 十二生肖
                            r.isPoultry = r.extendValue.isPoultry;// 是否家禽 true：是家禽 false：是野禽
                        }
                    }
                } else {
                    r.value = r.LotteryPlayDetailName;
                }
            });
            for (var i = 0; i < trCount; i++) {
                s.newParam[i] = {};
                s.newParam[i].tr = [];
                if (this.dollarInit.tdFirstName.length !== 0 && this.currlDollarCode != "1131" && this.currlDollarCode != "10250") {
                    s.newParam[i].tdFirstName = this.dollarInit.tdFirstName[i];
                }
                for (var j = i * n; j < n * (i + 1) && j < count; j++) {
                    if (this.dollarInit.tdFirstName.length !== 0) {
                        if (this.currlDollarCode == "1131" || this.currlDollarCode == "10250") {
                            s['Params'][j].tdFirstName = this.dollarInit.tdFirstName[event].nameArry[i];
                        }//龙虎玩法处理
                    }
                    s.newParam[i].tr.push(s['Params'][j]);
                }
            }
        });
    }
    // mask(o,l){

    //     this.shortcutStake(o, l);

    // }
    //快钱玩法快捷押注
    shortcutStake(o, l) {
        o.check = (!o.check) ? true : false;
        if (this.currlDollarType == 4 || this.currlDollarType == 5 || this.currlDollarType == 7) {
            this.dollarInit.bettingItemData.BettingItemList = [];
            this.locationRefer();
            this.btnUnclick();
            return;
        } else if (this.currlDollarType == 9) {
            this.dollarInit.bettingItemData.BettingItemList = [];
            this.treeGroupChoice(); //组选三提交
            return;
        } else if (this.currlDollarType == 10) {
            this.dollarInit.bettingItemData.BettingItemList = [];
            this.sixGroupChoice(); //组选六提交 
            return;
        }
        else if (this.currlDollarType == 34 || this.currlDollarType == 38 || this.currlDollarType == 39
            || this.currlDollarType == 40 || this.currlDollarType == 41) {
            this.LetteryMarkSixChoice(); //六合彩连码34，合肖38，连肖39 尾数连40，全不中41玩法提交
            this.btnUnclick();
            return;
        }
        if (this.currlDollarType == 14 && this.kqBettingMoney < 30) {
            this.kqBettingMoney = 30;
            this.alert.showAlert("该玩法最低投注额为30");
            this.reset();
            return;
        }


        if (o.check) {
            this.dollarsBettingList(o, l);
        }
        else {
            this.deleteDollarBet(o, l);
        }
        this.btnUnclick();

    }
    // 快钱投注集合
    dollarsBettingList(obj, label) {
        var money = this.kqBettingMoney;
        obj.BettingMoney = money;
        this.dollarInit.bettingItemData.noteTotal = 0;
        this.dollarInit.currBonus = this.dollarInit.BonusMode[0] * 10;
        let bet = new AnBetting();//双面盘单条下注
        bet.Position2 = label;
        bet.Position = label;
        bet.Position3 = obj.LotteryPlayDetailName;
        bet.BettingNumber = obj.LotteryPlayDetailName;
        bet.BettingMoney = obj.BettingMoney;
        bet.LotteryPlayDetailCode = obj.LotteryPlayDetailCode;
        bet.BettingOdds = obj.BettingOdds;
        bet.Modulus = 1;
        bet.RangeValue = this.dollarInit.rangeValue;
        bet.CardinalMoney = obj.CardinalMoney;
        bet.Rebate = this.dollarInit.currBonus;
        this.dollarInit.bettingItemData.BettingItemList.push(bet);
        this.getBettingItemString();
        this.dollarsBettingTotal();
    }

    /**
     * 获取快钱玩法投注期号集合信息
     * evan 2018-05-31
     * @memberof LotteryComponent
     */
    getDollarsIssueString() {
        let issueString = "";
        this.dollarInit.bettingItemData.BettingInfoIssueList.forEach((issue, index) => {
            issueString += issue.IssueNo + "@";
            issueString += issue.Multiple + "@";
            issueString += issue.PerPrice + "@";
            issueString += issue.BettingMoney + "|";
        })
        issueString = issueString.substr(0, issueString.length - 1);
        this.dollarInit.bettingItemData.BettingInfoIssueString = issueString;
    }

    /**
     * 获取快钱玩法投注内容集合信息
     * evan 2018-05-31
     * @memberof LotteryComponent
     */
    getBettingItemString(betList = null) {
        let bettingString = "";
        if (betList == null) {
            this.dollarInit.bettingItemData.BettingItemList.forEach((bet, index) => {
                bettingString += bet.LotteryPlayDetailCode + "@";
                bettingString += (index + 1) + "@";
                bettingString += bet.Position + "@";
                bettingString += bet.BettingNumber + "@";
                bettingString += bet.BettingMoney + "@";
                bettingString += bet.RangeValue + "@";
                bettingString += bet.BettingOdds + "@";
                bettingString += bet.Rebate + "|";
            })
        } else {
            betList.forEach((bet, index) => {
                bettingString += bet.LotteryPlayDetailCode + "@";
                bettingString += (index + 1) + "@";
                bettingString += bet.Position + "@";
                bettingString += bet.BettingNumber + "@";
                bettingString += bet.BettingMoney + "@";
                bettingString += bet.RangeValue + "@";
                bettingString += bet.BettingOdds + "@";
                bettingString += bet.Rebate + "|";
            })
        }
        bettingString = bettingString.substr(0, bettingString.length - 1);
        this.dollarInit.bettingItemData.BettingItemString = bettingString;
    }

    // 计算投注数
    dollarsBettingTotal(betList = null) {
        let noteTotal = 0,
            bettingMoneyTotal = 0;
        if (betList != null) {
            this.dollarInit.bettingItemData.noteTotal = noteTotal;
            betList.forEach((s, i) => {
                s.SerialNo = i;
                bettingMoneyTotal += s.BettingMoney;
                if (s.BetTotal) {
                    noteTotal += s.BetTotal;
                } else {
                    noteTotal++;
                }
            });
        }
        else {
            this.dollarInit.bettingItemData.BettingItemList.forEach((s, i) => {
                noteTotal++;
                bettingMoneyTotal += s.BettingMoney;
                s.SerialNo = i;
            });
            this.dollarInit.bettingItemData.noteTotal = noteTotal;
            this.dollarInit.bettingItemData.BettingMoney = bettingMoneyTotal;
        }
    }
    //删除单条投注记录
    deleteDollarBet(res, l) {
        var index = this.dollarInit.bettingItemData.BettingItemList.findIndex((item, index) => {
            return res.LotteryPlayDetailCode === item.LotteryPlayDetailCode
                && item.Position === l && item.BettingOdds === res.BettingOdds
        });
        this.dollarInit.bettingItemData.BettingItemList.splice(index, 1);
        this.getBettingItemString();
        this.dollarsBettingTotal();
    }

    //手动输入快捷投注金额，ngModel中value转换类型Int

    fontshortcutFarmarInt(num) {
        this.midValue = num;
        let reg = /^\d+(?=\.{0,1}\d+$|$)/;//验证正数
        let n = parseFloat(num);
        this.kqBettingMoney = (reg.test(num)) ? n : 0;
    }
    //只允许数字输入和delete键
    onKeyPress(event: any) {
        let keyCode = event.keyCode;
        if (keyCode >= 48 && keyCode <= 57 || keyCode == 8 || keyCode >= 96 && keyCode <= 105) {
            event.returnValue = true;
        }
        else {
            event.returnValue = false;
        }
    }
    // 输入栏单击添加数字
    addnum() {
        let a = $("#pcdd").val();
        a++;
        $("#pcdd").val(a);
    }
    cutdownnum() {
        let b = $("#pcdd").val();
        b--;
        $("#pcdd").val(b);
    }
    // 快钱玩法投注重置
    shortcutReset() {
        this.tempSexCardArr = [];
        var playMode = this.dollarInit.currlottery.PlayMode;
        this.dollarInit.bettingItemData.noteTotal = 0;
        this.dollarInit.newDollarsBetting = JSON.parse(JSON.stringify(this.dollarInit.newDollarsBettingClone));
        this.dollarInit.rangeValue = this.dollarInit.maxnum;
        if (playMode.LotteryPlayModeTypeCode == 4 || playMode.LotteryPlayModeTypeCode == 5 || playMode.LotteryPlayModeTypeCode == 7) {
            this.dollarInit.currCardinalMoney = playMode.PlayDetails[0].CardinalMoney1;
        } //重置二字定位，三字定位，二字组合
        if (playMode.LotteryPlayModeTypeCode == 9 || playMode.LotteryPlayModeTypeCode == 10) {
            this.dollarInit.groupCheckParam.cardinalMoneyAttr = [0, 0, 0];
        } //重置组选三组选六
        // if (playMode.LotteryPlayModeTypeCode == 9 || playMode.LotteryPlayModeTypeCode == 10) {
        //     this.dollarInit.groupCheckParam.cardinalMoneyAttr = [0, 0, 0];
        // }
        this.recombineDollars();

    }

    reset() {
        this.shortcutReset();
        this.clearBetting();
        this.groupTreeArray = [];
        this.tempSexCardArr = [];
        this.dollarInit.bettingItemData.noteTotal = 0;
        this.dollarInit.bettingItemData.BettingMoney = 0;
        this.dollarInit.bettingItemData.BettingItemList = [];
    }
    // 定位玩法投注
    locationRefer() {
        this.clearBetting();
        var n = this.currlDollarType == 4 ? 2 : 3;  //判断是二字定位还是三字定位
        var wan = [], qian = [], bai = [], shi = [], ge = [];
        this.dollarInit.newDollarsBetting.forEach(r => {
            r.Params.forEach(s => {
                if (s.check) {
                    if (r.Label == '万位') {
                        wan.push(s.LotteryPlayDetailName);
                    }
                    else if (r.Label == '千位') {
                        qian.push(s.LotteryPlayDetailName);
                    }
                    else if (r.Label == '百位') {
                        bai.push(s.LotteryPlayDetailName);
                    }
                    else if (r.Label == '十位') {
                        shi.push(s.LotteryPlayDetailName);
                    }
                    else if (r.Label == '个位') {
                        ge.push(s.LotteryPlayDetailName);
                    }
                }
            });
        });

        var count = 0;
        count += wan.length > 0 ? 1 : 0;
        count += qian.length > 0 ? 1 : 0;
        count += bai.length > 0 ? 1 : 0;
        count += shi.length > 0 ? 1 : 0;
        count += ge.length > 0 ? 1 : 0;

        if (count < n) {
            return;
        }
        if (count > n) {
            this.alert.showAlert("请选择 " + n + " 位的号码进行投注！");
            return;
        }
        var nameArr = [];
        var dataArr = [];
        if (wan.length > 0) {
            nameArr.push("万");
            var tmp = [];
            $.each(wan, function (index, value) {
                tmp.push(value);
            });
            dataArr.push(tmp);
        }
        if (qian.length > 0) {
            nameArr.push("千");
            var tmp = [];
            $.each(qian, function (index, value) {
                tmp.push(value);
            });
            dataArr.push(tmp);
        }
        if (bai.length > 0) {
            nameArr.push("百");
            var tmp = [];
            $.each(bai, function (index, value) {
                tmp.push(value);
            });
            dataArr.push(tmp);
        }
        if (shi.length > 0) {
            nameArr.push("十");
            var tmp = [];
            $.each(shi, function (index, value) {
                tmp.push(value);
            });
            dataArr.push(tmp);
        }
        if (ge.length > 0) {
            nameArr.push("个");
            var tmp = [];
            $.each(ge, function (index, value) {
                tmp.push(value);
            });
            dataArr.push(tmp);
        }

        if (n == 2) {
            this.twoWordGroup(dataArr, nameArr, this.dollarInit.currCardinalMoney, "")
        }
        else {
            this.treeWordGroup(dataArr, nameArr, this.dollarInit.currCardinalMoney, "")
        }
    }
    // 二字相关玩法下注排列组合
    twoWordGroup(arr1, arr2, cardinal, name) {
        this.dollarInit.currBonus = this.dollarInit.BonusMode[0] * 10;
        var money = this.kqBettingMoney;
        for (var i = 0; i < arr1[0].length; ++i) {
            for (var j = 0; j < arr1[1].length; ++j) {
                let bet = new AnBetting();
                bet.Position1 = name;

                bet.BettingNumber = arr1[0][i] + "," + arr1[1][j];
                bet.Position2 = arr2[0] + '-' + arr1[0][i];
                bet.Position3 = arr2[1] + '-' + arr1[1][j];
                bet.BettingMoney = money;
                bet.BettingOdds = cardinal;
                bet.Rebate = this.dollarInit.currBonus;
                if (this.dollarInit.currlottery.PlayMode.LotteryPlayModeTypeCode == 7) {
                    bet.Position = name;
                }
                else {
                    bet.Position = this.fontPosition(arr2[0]) + "," + this.fontPosition(arr2[1]);
                }
                this.dollarInit.bettingItemData.BettingItemList.push(bet);
            }
        }

        // this.dollarInit.bettingMoneyCount.BettingItemList.forEach((item, index) => {
        //     if (this.dollarInit.currlottery.PlayMode.LotteryPlayModeTypeCode == 7) {
        //         if (item.BettingNumber.split(',')[0] == item.BettingNumber.split(',')[1]) {
        //             this.dollarInit.bettingMoneyCount.BettingItemList.splice(index, 1);
        //         }
        //     }
        // })

        let numString1 = '', numString2 = '', pairsNum = 0, bettingItemList = [];
        for (var i = 0; i < arr1[0].length; i++) {
            numString1 += arr1[0][i] + "";
            // for (var j = 0; j < arr1[1].length; j++) {
            //     if (arr1[1][j] == arr1[0][i]) {
            //         pairsNum += 1;  //对子的个数 
            //     }
            // }
        }
        for (var j = 0; j < arr1[1].length; j++) {
            numString2 += arr1[1][j] + "";
        }
        let bet1 = new AnBetting();
        bet1.Position = name;
        bet1.BettingNumber = numString1 + "," + numString2;
        bet1.BettingMoney = money * arr1[0].length * arr1[1].length;
        bet1.BetTotal = arr1[0].length * arr1[1].length;
        bet1.RangeValue = this.dollarInit.rangeValue;
        bet1.BettingOdds = cardinal;
        bet1.Rebate = this.dollarInit.currBonus;
        if (this.dollarInit.currlottery.PlayMode.LotteryPlayModeTypeCode == 7) {
            bet1.Position = name + "二字组合";
            bet1.Position2 = numString1;
            bet1.Position3 = numString2;
            // bet1.BetTotal = bet1.BetTotal ;
            // bet1.BettingMoney = money * bet1.BetTotal;
            bet1.LotteryPlayDetailCode = this.openType;
        } else {
            bet1.Position = this.fontPosition(arr2[0]) + "," + this.fontPosition(arr2[1]);
            bet1.Position2 = arr2[0] + "-" + arr2[1];
            bet1.Position3 = numString1 + "," + numString2;
            bet1.LotteryPlayDetailCode = this.dollarInit.currlottery.PlayMode.PlayDetails[0].LotteryPlayDetailCode;
        }
        bettingItemList.push(bet1);
        this.getBettingItemString(bettingItemList);
        this.dollarsBettingTotal();
    }


    // 三字相关玩法下注排列组合
    treeWordGroup(arr1, arr2, cardinal, name) {
        this.dollarInit.currBonus = this.dollarInit.BonusMode[0] * 10;
        var money = this.kqBettingMoney;
        for (var i = 0; i < arr1[0].length; ++i) {
            for (var j = 0; j < arr1[1].length; ++j) {
                for (var k = 0; k < arr1[2].length; ++k) {
                    let bet = new AnBetting();
                    bet.Position = this.fontPosition(arr2[0]) + "," + this.fontPosition(arr2[1]) + "," + this.fontPosition(arr2[2]);
                    bet.BettingNumber = arr1[0][i] + "," + arr1[1][j] + "," + arr1[2][k];
                    bet.Position1 = arr1[0][i] + '-' + arr1[1][j] + '-' + arr1[2][k];
                    bet.Position2 = arr2[0] + '-' + arr2[1] + '-' + arr2[2];
                    bet.Position3 = arr1[0][i] + '-' + arr1[1][j] + '-' + arr1[2][k];
                    bet.BettingMoney = money;
                    bet.LotteryPlayDetailCode = this.dollarInit.currlottery.PlayMode.PlayDetails[0].LotteryPlayDetailCode;
                    bet.BettingOdds = cardinal;
                    bet.Rebate = this.dollarInit.currBonus;
                    this.dollarInit.bettingItemData.BettingItemList.push(bet);
                }
            }
        }

        let numString1 = "", numString2 = "", numString3 = "", bettingItemList = [];
        for (var j = 0; j < arr1[0].length; j++) {
            numString1 += arr1[0][j] + "";
        }
        for (var j = 0; j < arr1[1].length; j++) {
            numString2 += arr1[1][j] + "";
        }
        for (var j = 0; j < arr1[2].length; j++) {
            numString3 += arr1[2][j] + "";
        }

        this.dollarInit.currBonus = this.dollarInit.BonusMode[0] * 10;
        var money = this.kqBettingMoney;
        let bet1 = new AnBetting();
        bet1.Position = name + "三字组合";
        bet1.Position = this.fontPosition(arr2[0]) + "," + this.fontPosition(arr2[1]) + "," + this.fontPosition(arr2[2]);
        bet1.Position2 = arr2[0] + "-" + arr2[1] + "-" + arr2[2];
        bet1.Position3 = numString1 + "," + numString2 + "," + numString3;
        bet1.BettingNumber = numString1 + "," + numString2 + "," + numString3;
        bet1.BettingMoney = money * arr1[0].length * arr1[1].length * arr1[2].length;
        bet1.BetTotal = arr1[0].length * arr1[1].length * arr1[2].length;
        bet1.RangeValue = this.dollarInit.rangeValue;
        bet1.LotteryPlayDetailCode = this.dollarInit.currlottery.PlayMode.PlayDetails[0].LotteryPlayDetailCode;
        bet1.BettingOdds = cardinal;
        bet1.Rebate = this.dollarInit.currBonus;
        this.dollarInit.bettingItemData.noteTotal = arr1[0].length * arr1[1].length * arr1[2].length;
        bettingItemList.push(bet1);
        this.getBettingItemString(bettingItemList);
        this.dollarsBettingTotal();
    }
    // 二字组合提交
    groupRefer(o, j) {
        o.check = (!o.check) ? true : false;
        this.clearBetting();
        var betObj = { first: [], second: [] };
        this.dollarInit.newDollarsBetting[j].newParam.forEach(s => {
            s.tr.forEach(r => {
                if (r.check) {
                    if (s.tdFirstName == '第一个号') {
                        betObj.first.push(r.LotteryPlayDetailName);
                    }
                    else if (s.tdFirstName == '第二个号') {
                        betObj.second.push(r.LotteryPlayDetailName);
                    }
                }
            });
        });
        var count = 0;
        count += betObj.first.length > 0 ? 1 : 0;
        count += betObj.second.length > 0 ? 1 : 0;
        if (count == 1) {
            return;
        }

        var nameArr = [];
        var dataArr = [];
        if (betObj.first.length > 0) {
            nameArr.push("第一个号");
            var tmp = [];
            $.each(betObj.first, function (index, value) {
                tmp.push(value);
            });
            dataArr.push(tmp);
        }
        if (betObj.second.length > 0) {
            nameArr.push("第二个号");
            var tmp = [];
            $.each(betObj.second, function (index, value) {
                tmp.push(value);
            });
            dataArr.push(tmp);
        }
        if (dataArr.length != 0 && nameArr.length != 0) {
            this.twoWordGroup(dataArr, nameArr, this.dollarInit.currCardinalMoney, this.dollarInit.newDollarsBetting[j].Label);
        }
        this.btnUnclick();
    }
    // 组选三赔率变化
    treeGroupCardinalMoney(item, j) {
        item.check = (!item.check) ? true : false;
        if (item.check) {
            this.groupTreeArray.push(item);
        }
        else {
            let index = this.groupTreeArray.indexOf(item);
            this.groupTreeArray.splice(index, 1);
        }
        let arr = this.groupTreeArray;
        this.dollarInit.groupCheckParam.index = j;
        var code = this.dollarInit.newDollarsBetting[this.dollarInit.groupCheckParam.index].AlgorithmCode;
        var details = this.dollarInit.groupAttr[code];
        if (arr.length >= 5) {
            this.dollarInit.groupCheckParam.count = arr.length;
            this.dollarInit.groupCheckParam.order = this.fontCode(this.dollarInit.groupCheckParam.count);
            let cardinalMoney = details[this.dollarInit.groupCheckParam.order].CardinalMoney,
                rewardUp = this.dollarInit.BonusMode[1],
                modulus = details[this.dollarInit.groupCheckParam.order].Modulus;
            this.dollarInit.groupCheckParam.cardinalMoneyAttr[j] = parseFloat(this.countOdds(cardinalMoney, rewardUp, modulus));
            this.treeGroupChoice(j);
        } else {
            this.dollarInit.groupCheckParam.count = arr.length;
            this.dollarInit.groupCheckParam.cardinalMoneyAttr[j] = 0;
            this.dollarInit.bettingItemData.BettingItemList = [];
            // this.treeGroupChoice(j);
            this.dollarsBettingTotal();
            this.getBettingItemString();
        }
        this.btnUnclick();

    }
    btnUnclick() {
        let mon = this.storage.read<UserModel>('User').UserMoney;
        let noBalance: number = mon - this.dollarInit.bettingItemData.BettingMoney;
        if (noBalance < 0) {
            this.alert.showAlert("余额不足");
            this.unclick = false;
            return
        } else {
            this.unclick = true;
        }
    }
    // 组选三提交
    treeGroupChoice(j = 0) {
        this.dollarInit.bettingItemData.BettingItemList = [];
        var money = this.kqBettingMoney;
        this.dollarInit.currBonus = this.dollarInit.BonusMode[0] * 10
        var code = this.dollarInit.newDollarsBetting[this.dollarInit.groupCheckParam.index].AlgorithmCode;
        var details = this.dollarInit.groupAttr[code];
        let bet = new AnBetting();
        var valueObj = "";
        this.groupTreeArray.forEach((item, i) => { valueObj += "," + item.value; });
        bet.BettingNumber = valueObj.substring(1, valueObj.length);
        bet.Position2 = this.dollarInit.newDollarsBetting[this.dollarInit.groupCheckParam.index].Label;
        bet.Position = this.dollarInit.newDollarsBetting[this.dollarInit.groupCheckParam.index].Label + "组选三";
        bet.Position3 = valueObj.substring(1, valueObj.length);
        bet.BettingMoney = money;
        bet.BettingOdds = this.dollarInit.groupCheckParam.cardinalMoneyAttr[this.dollarInit.groupCheckParam.index];
        bet.RangeValue = this.dollarInit.rangeValue;
        bet.Rebate = this.dollarInit.currBonus;
        bet.LotteryPlayDetailCode = details[this.dollarInit.groupCheckParam.order].LotteryPlayDetailCode;
        this.dollarInit.bettingItemData.BettingItemList.push(bet);
        this.dollarsBettingTotal();
        this.getBettingItemString();
    }

    // 组选六赔率变化
    sixGroupCardinalMoney(item, j) {
        item.check = (!item.check) ? true : false;
        if (item.check) {
            this.groupTreeArray.push(item);
        }
        else {
            let index = this.groupTreeArray.indexOf(item);
            this.groupTreeArray.splice(index, 1);
        }
        let arr = this.groupTreeArray;
        this.dollarInit.groupCheckParam.index = j;
        var code = this.dollarInit.newDollarsBetting[this.dollarInit.groupCheckParam.index].AlgorithmCode;
        var details = this.dollarInit.groupAttr[code];
        if (arr.length >= 4 && arr.length <= 8) {
            this.dollarInit.groupCheckParam.count = arr.length;
            this.dollarInit.groupCheckParam.order = this.fontCode(this.dollarInit.groupCheckParam.count);
            var cardinalMoney =
                details[this.dollarInit.groupCheckParam.order].CardinalMoney,
                rewardUp = this.dollarInit.BonusMode[1],
                modulus = details[this.dollarInit.groupCheckParam.order].Modulus;
            this.dollarInit.groupCheckParam.cardinalMoneyAttr[j] = parseFloat(this.countOdds(cardinalMoney, rewardUp, modulus));
            this.sixGroupChoice(j);
        } else {
            this.dollarInit.groupCheckParam.cardinalMoneyAttr[j] = 0;
            this.dollarInit.bettingItemData.BettingItemList = [];
            this.dollarsBettingTotal();
            this.getBettingItemString();
        }
        this.btnUnclick();
    }

    //组选六提交
    sixGroupChoice(j = 0) {
        this.dollarInit.bettingItemData.BettingItemList = [];
        var money = this.kqBettingMoney;
        this.dollarInit.currBonus = this.dollarInit.BonusMode[0] * 10
        var code = this.dollarInit.newDollarsBetting[this.dollarInit.groupCheckParam.index].AlgorithmCode;
        var details = this.dollarInit.groupAttr[code];
        let bet = new AnBetting();
        var valueObj = "";
        this.groupTreeArray.forEach((item, i) => { valueObj += "," + item.value; });
        bet.BettingNumber = valueObj.substring(1, valueObj.length);
        // bet.Position2 = this.dollarInit.currGroupName;
        bet.Position2 = this.treeGroupName + '';
        // bet.Position = this.dollarInit.currGroupName + "组选六";
        bet.Position = this.treeGroupName + "组选六";
        bet.Position3 = valueObj.substring(1, valueObj.length);
        bet.BettingMoney = money;
        bet.BettingOdds = this.dollarInit.groupCheckParam.cardinalMoneyAttr[this.dollarInit.groupCheckParam.index];
        bet.RangeValue = this.dollarInit.rangeValue;
        bet.Rebate = this.dollarInit.currBonus;
        bet.LotteryPlayDetailCode = details[this.dollarInit.groupCheckParam.order].LotteryPlayDetailCode;
        this.dollarInit.bettingItemData.BettingItemList.push(bet);
        this.dollarsBettingTotal();
        this.getBettingItemString();
    }

    //二字组合切换
    changeType() {
        this.groupTreeArray = [];
        this.tempSexCardArr = [];
        // this.shortcutReset();
        this.recombineDollars();

        switch (this.openType) {
            case '1127':
                this.treeGroupName = '前三';
                break;
            case '1128':
                this.treeGroupName = '中三';
                break;
            case '1129':
                this.treeGroupName = '后三';
                break;
        }
    }

    lhcChange(value, index, type) {
        this.tempSexCardArr = [];
        this.openType = value;
        let $tab = document.getElementsByClassName('segment-tab' + type)[index];
        $tab.setAttribute('class', 'segment-button segment-activated' + ' segment-tab' + type);
    }

    //赔率调节
    //Tony
    bonusMode() {
        // var increaseBonus = this.sysconfig.BonusGruduation * (this.dollarInit.baseReward - this.dollarInit.rangeValue) / this.sysconfig.PerGraduation;
        var increaseBonus = this.indexExtend.accDiv(this.indexExtend.accMul(this.sysconfig.BonusGruduation, this.indexExtend.accSub(this.dollarInit.baseReward, this.dollarInit.rangeValue)), this.sysconfig.PerGraduation);
        var currentBonus = this.currUser.Bonus + increaseBonus;
        currentBonus = currentBonus > this.sysconfig.AdjustMaxBonus ? this.sysconfig.AdjustMaxBonus : currentBonus;
        currentBonus = currentBonus < this.sysconfig.AdjustMinBonus ? this.sysconfig.AdjustMinBonus : currentBonus;
        this.dollarInit.BonusMode = [parseFloat(currentBonus.toFixed(2)), this.dollarInit.currlottery.LotteryTypeCode == "02" ? this.dollarInit.rangeValue : this.dollarInit.rangeValue];
    }

    OddsChange() {
        let LotteryPlayModeTypeCode = this.dollarInit.currlottery.PlayMode.LotteryPlayModeTypeCode;
        this.bonusMode();
        var cardinalMoney,
            rewardUp = this.dollarInit.BonusMode[1],
            modulus;
        if (LotteryPlayModeTypeCode == 4 || LotteryPlayModeTypeCode == 5 || LotteryPlayModeTypeCode == 7) {
            cardinalMoney = this.dollarInit.currlottery.PlayMode.PlayDetails[0].CardinalMoney;
            modulus = this.dollarInit.currlottery.PlayMode.PlayDetails[0].Modulus;
            this.dollarInit.currCardinalMoney = this.countOdds(cardinalMoney, rewardUp, modulus);
            this.locationRefer();
            this.btnUnclick();
            return;
        }//二字定位，三字定位，二字组合赔率调节
        else if (LotteryPlayModeTypeCode == 9 || LotteryPlayModeTypeCode == 10) {
            let i = this.dollarInit.groupCheckParam.index;
            var code = this.dollarInit.newDollarsBetting[i].AlgorithmCode;
            var details = this.dollarInit.groupAttr[code];
            cardinalMoney = details[this.dollarInit.groupCheckParam.order].CardinalMoney;
            modulus = details[this.dollarInit.groupCheckParam.order].Modulus;
            this.dollarInit.groupCheckParam.cardinalMoneyAttr[i] = this.countOdds(
                cardinalMoney,
                rewardUp,
                modulus
            );
            this.dollarInit.bettingItemData.BettingItemList = [];
            if (LotteryPlayModeTypeCode == 9) {
                this.treeGroupChoice();
            } else if (LotteryPlayModeTypeCode == 10) {
                this.sixGroupChoice();
            }
            return;
        } //组选三,组选六赔率调节
        this.dollarInit.newDollarsBetting.forEach(r => {
            r.Params.forEach(s => {
                var cardinalMoney = s.CardinalMoney,
                    rewardUp = this.dollarInit.BonusMode[1],
                    modulus = s.Modulus;
                s.BettingOdds = this.countOdds(cardinalMoney, rewardUp, modulus);
            });
        });

    }

    // 赔率计算 c:CardinalMoney官方奖金,r:RewardUp用户调节刻度,m:Modulus微调
    countOdds(c, r, m) {
        var odds;
        c = Number(c);
        m = Number(m) || 0;
        r = Number(r);
        var configuredRewardUp = Number(this.sysconfig.RewardUp) || 0;
        var basicReward = Number(this.sysconfig.BasicReward) || 0;
        var rewardUp = Number(this.dollarInit.rewardUp);
        rewardUp = isNaN(rewardUp) ? configuredRewardUp : rewardUp;
        var baseReward = configuredRewardUp == 0 ? basicReward : basicReward + (rewardUp - configuredRewardUp);
        r = isNaN(r) ? baseReward : r;
        if (isNaN(c)) {
            return "0.000";
        }
        // odds = ((baseReward + this.sysconfig.PerGraduation * ((r - baseReward) / 2)) * c / 1000 + m) * 1 / 2;
        // // return (odds).toFixed(3);
        // return (Math.round(odds * 1000) / 1000).toFixed(3);
        let perGraduation = Number(this.sysconfig.PerGraduation) || 0;
        let value = this.indexExtend.accMul(this.indexExtend.accAdd(baseReward, this.indexExtend.accMul(perGraduation, this.indexExtend.accDiv(this.indexExtend.accSub(r, baseReward), 2.0))), c);
        let x = this.indexExtend.accMul(this.indexExtend.accAdd(this.indexExtend.accDiv(value, 1000), m), 1);
        odds = this.indexExtend.accDiv(x, 2);
        return this.indexExtend.toFixedExprend(odds, 3);
    }


    // 追号序列 i:IssueNo期号 m:Multiple倍数 
    dollarsChaseArray(i, m) {
        let attr = new ChaseBetting();
        attr.IssueNo = i;
        attr.Multiple = m;
        attr.PerPrice = 1;
        attr.BettingMoney = this.dollarInit.bettingItemData.BettingMoney * m;
        this.dollarInit.bettingItemData.BettingInfoIssueList.push(attr);
        this.dollarInit.bettingItemData.BettingItemList.forEach(s => {
            s.BettingMoney = this.kqBettingMoney;
        });
        this.getDollarsIssueString();
    }
    //写入投注成功的数据
    betSuccess() {
        let currLottery = { LotteryName: this.initCurrLottery.LotteryName, LotteryCode: this.initCurrLottery.LotteryCode };
        //读取storage是否存在数据
        let storageLotterys = this.storage.read<StorageLottery[]>('betLottery');
        //如果betLottery不存在数据，写入数据
        if (!storageLotterys || storageLotterys.length < 1) {
            storageLotterys = [];
            storageLotterys.push(currLottery);
        } else {
            //如果存在
            let indx = storageLotterys.findIndex(s => s.LotteryCode == this.initCurrLottery.LotteryCode);
            //如果betLottery中存在当前彩种，不追加当前数据
            //如果betLottery中不存在当前彩种，追加当前数据
            if (indx < 0) {
                storageLotterys.push(currLottery);
            }
        }
        this.storage.write('betLottery', storageLotterys);
    }


    integrationParams() {
        this.dollarInit.currBonus = this.dollarInit.BonusMode[0] * 10;
        if (this.currentDail.LotteryPlayModeName == '二字定位' ||
            this.currentDail.LotteryPlayModeName == '三字定位' ||
            this.currentDail.LotteryPlayModeName == '二字组合' ||
            this.currentDail.LotteryPlayModeName == '组选三' ||
            this.currentDail.LotteryPlayModeName == '组选六') {
            return
        } else {
            this.dollarInit.newDollarsBetting.forEach(s => {
                s.Params.forEach(r => {
                    if (r.BettingMoney != 0) {
                        let bet = new AnBetting(); //双面盘单条下注
                        bet.Position2 = s.Label;
                        bet.Position = s.Label;
                        if (r.tdFirstName && (this.dollarInit.currlottery.PlayMode.LotteryPlayModeTypeCode == 12 ||
                            this.dollarInit.currlottery.PlayMode.LotteryPlayModeTypeCode == 22)) {
                            bet.Position2 = r.tdFirstName;
                            bet.Position = r.tdFirstName;
                        }
                        bet.Position3 = r.LotteryPlayDetailName;
                        bet.BettingNumber = r.LotteryPlayDetailName;
                        bet.BettingMoney = r.BettingMoney;
                        bet.LotteryPlayDetailCode = r.LotteryPlayDetailCode;
                        bet.BettingOdds = r.BettingOdds;
                        bet.Modulus = r.Modulus;
                        bet.RangeValue = this.dollarInit.rangeValue;
                        bet.CardinalMoney = r.CardinalMoney;
                        bet.Rebate = this.dollarInit.currBonus;
                        this.dollarInit.bettingItemData.BettingItemList.push(bet);
                    }

                });
            });
            this.getBettingItemString();
        }

    }

    // 投注确认提交
    ReferResult() {
        if (!this.tempSexCardArr[0] && (this.currlDollarType == 40 || this.currlDollarType == 39)) {
            this.alert.showAlert("您还没有下注哦!");
            return;
        }
        if ((this.currlDollarType == 40 || this.currlDollarType == 39)) {
            this.checkBetting(this.tempSexCardArr[0]);
        }
        let ajaxList = [];
        let errors = [];
        var bettingCount = this.dollarInit.bettingItemData.BettingItemList.length;
        if (bettingCount == 0) {
            this.alert.showAlert("请正确选择投注！");
            return;
        }
        // 一键投注在清空对象列表前，先生成后端需要的投注项字符串。
        this.getBettingItemString();
        if (!this.dollarInit.bettingItemData.BettingItemString) {
            this.alert.showAlert("投注内容为空，请重新选择投注项");
            return;
        }
        this.dollarInit.bettingItemData.BettingInfoIssueList = [];
        this.dollarInit.bettingItemData.IsChaseNo = 0;
        this.dollarInit.bettingItemData.IsStopAfterWinning = 0;
        this.dollarInit.bettingItemData.BettingMoney = 0;
        this.dollarInit.bettingItemData.BettingItemList.forEach((s, i) => {
            this.dollarInit.bettingItemData.BettingMoney += s.BettingMoney;
            this.dollarInit.bettingItemData.rewardPar += this.indexExtend.accMul(s.BettingMoney, s.BettingOdds);
        })


        if (this.dollarInit.bettingItemData.BettingMoney > this.kqHighFrequencyPerMaxReward && this.kqHighFrequencyPerMaxReward > 0) {
            // this.alert.showAlert(`奖金即将超过限额${permax},是否继续投注?`);
            // return false;
            this.alert.showConfirm(`奖金可能超过限额${this.kqHighFrequencyPerMaxReward},是否继续投注?`, () => {
                let bettMoney = this.dollarInit.bettingItemData.BettingMoney; //投注金额
                let rewardPar = this.dollarInit.bettingItemData.rewardPar;
                // if (rewardPar > 0 && bettMoney / rewardPar <= this.headsupRatio && this.headsupRatio > 0) {
                //     this.alert.showConfirm(`中奖率低于${this.headsupRatio * 100}%的单挑最高派奖为${this.HeadsupRewardMax / 10000}万元`, () => {
                //         this.getIssue((s) => {
                //             this.dollarInit.bettingItemData.IssueNo = s.CurrentIssueNo;
                //             this.dollarsChaseArray(this.dollarInit.bettingItemData.IssueNo, 1);
                //             let bettingInfo = new BettingMoneyCountModel();
                //             bettingInfo = this.dollarInit.bettingItemData;
                //             bettingInfo.BettingInfoIssueList = [];
                //             bettingInfo.BettingItemList = [];
                //             this.integrationParams();
                //             ajaxList.push(this.bettingService.dollarBetting(bettingInfo));
                //             ajaxList.forEach(r => {
                //                 r.then(s => {
                //                     if (!s.Result) {
                //                         errors.push(s);
                //                     }
                //                 });
                //             });
                //             this.submitBetting(ajaxList, errors, () => {
                //                 // this.betSuccess();
                //                 // this.reset();
                //             });
                //         });
                //     });
                // } else {
                    this.getIssue((s) => {
                        this.dollarInit.bettingItemData.IssueNo = s.CurrentIssueNo;
                        this.dollarsChaseArray(this.dollarInit.bettingItemData.IssueNo, 1);
                        let bettingInfo = new BettingMoneyCountModel();
                        bettingInfo = this.dollarInit.bettingItemData;
                        bettingInfo.BettingInfoIssueList = [];
                        bettingInfo.BettingItemList = [];
                        ajaxList.push(this.bettingService.dollarBetting(bettingInfo));
                        ajaxList.forEach(r => {
                            r.then(s => {
                                if (!s.Result) {
                                    errors.push(s);
                                }
                            });
                        });
                        this.submitBetting(ajaxList, errors, () => {
                            // this.betSuccess();
                            // this.reset();
                        });
                    });
                // }
            })
        } else {
            let bettMoney = this.dollarInit.bettingItemData.BettingMoney; //投注金额
            let rewardPar = this.dollarInit.bettingItemData.rewardPar;
            // if (rewardPar > 0 && bettMoney / rewardPar <= this.headsupRatio && this.headsupRatio > 0) {
            //     this.alert.showConfirm(`中奖率低于${this.headsupRatio * 100}%的单挑最高派奖为${this.HeadsupRewardMax / 10000}万元`, () => {
            //         this.getIssue((s) => {
            //             this.dollarInit.bettingItemData.IssueNo = s.CurrentIssueNo;
            //             this.dollarsChaseArray(this.dollarInit.bettingItemData.IssueNo, 1);
            //             let bettingInfo = new BettingMoneyCountModel();
            //             bettingInfo = this.dollarInit.bettingItemData;
            //             bettingInfo.BettingInfoIssueList = [];
            //             bettingInfo.BettingItemList = [];
            //             this.integrationParams();
            //             ajaxList.push(this.bettingService.dollarBetting(bettingInfo));
            //             ajaxList.forEach(r => {
            //                 r.then(s => {
            //                     if (!s.Result) {
            //                         errors.push(s);
            //                     }
            //                 });
            //             });
            //             this.submitBetting(ajaxList, errors, () => {
            //                 // this.betSuccess();
            //                 // this.reset();
            //             });
            //         });
            //     });
            // } else {
                this.getIssue((s) => {
                    this.dollarInit.bettingItemData.IssueNo = s.CurrentIssueNo;
                    this.dollarsChaseArray(this.dollarInit.bettingItemData.IssueNo, 1);
                    let bettingInfo = new BettingMoneyCountModel();
                    bettingInfo = this.dollarInit.bettingItemData;
                    bettingInfo.BettingInfoIssueList = [];
                    bettingInfo.BettingItemList = [];
                    ajaxList.push(this.bettingService.dollarBetting(bettingInfo));
                    ajaxList.forEach(r => {
                        r.then(s => {
                            if (!s.Result) {
                                errors.push(s);
                            }
                        });
                    });
                    this.submitBetting(ajaxList, errors, () => {
                        // this.betSuccess();
                        // this.reset();
                    });
                });
            // }
        }


        // this.getIssue((s) => {
        //     this.dollarInit.bettingItemData.IssueNo = s.CurrentIssueNo;
        //     this.dollarsChaseArray(this.dollarInit.bettingItemData.IssueNo, 1);
        //     let bettingInfo = new BettingMoneyCountModel();
        //     bettingInfo = this.dollarInit.bettingItemData;
        //     bettingInfo.BettingInfoIssueList = [];
        //     bettingInfo.BettingItemList = [];
        //     this.integrationParams();
        //     ajaxList.push(this.bettingService.dollarBetting(bettingInfo));
        //     ajaxList.forEach(r => {
        //         r.then(s => {
        //             if (!s.Result) {
        //                 errors.push(s);
        //             }
        //         });
        //     });
        //     this.submitBetting(ajaxList, errors, () => {
        //         // this.betSuccess();
        //         // this.reset();
        //     });
        // });

    }
    //确认投注ajax
    //tony 2017-12-22
    submitBetting(ajaxList, errors, fn) {
        let load = this.loadding.showLoding("投注中...");
        Promise.all(ajaxList).then(() => {
            if (errors.length > 0) {
                var errorhtml = [];
                errors.forEach(e => {
                    errorhtml.push(e.Error);
                });
                this.alert.showAlert(errorhtml.join(''));
            } else {
                this.alert.showAlert("投注成功");
                this.reUserMoney();
                this.clearBetting();
                this.recombineDollars();
                this.groupTreeArray = [];
                this.tempSexCardArr = [];
                // this.reset();
                fn();
            }
            this.loadding.closeLoading(load);
        }).catch(c => {
            if (c.status === 401 || c.status === 403) {
                this.alert.showAlert("验证已失效，您需要退出重新登录!");
                localStorage.clear();
                this.appCtrl.getRootNav().setRoot(SigninPage);
                this.loadding.closeLoading(load);
            }
        });
    }
    //二字定位，三字定位位置代号
    fontPosition(attr) {
        switch (attr) {
            case "万":
                return "0";
            case "千":
                return "1";
            case "百":
                return "2";
            case "十":
                return "3";
            case "个":
                return "4";
        }
    }
    fontCode(count) {
        let playMode = this.dollarInit.currlottery.PlayMode;
        if (playMode.LotteryPlayModeTypeCode == 9) {
            switch (count) {
                case 5:
                    return 0;
                case 6:
                    return 1;
                case 7:
                    return 2;
                case 8:
                    return 3;
                case 9:
                    return 4;
                case 10:
                    return 5;
            }
        }
        if (playMode.LotteryPlayModeTypeCode == 10) {
            switch (count) {
                case 4:
                    return 0;
                case 5:
                    return 1;
                case 6:
                    return 2;
                case 7:
                    return 3;
                case 8:
                    return 4;
            }
        }

    }
    showLoading() {
        this.loadingCtrl.create({
            duration: 300,
            content: '加载中 ...'
        }).present();
    }


    clearBetting() {
        this.dollarInit.bettingItemData.noteTotal = 0;
        this.dollarInit.bettingItemData.BettingMoney = 0;
        this.dollarInit.bettingItemData.BettingItemList = [];
    }

}
//快钱玩法集合
export class dollarInitParams {
    currlottery = new CurrLotteryModel();
    tableHeadName = [];
    headName = [];
    tdFirstName = [];
    lumpCount = 0;
    lumpSonCount = 0;
    currGroupName = "前三";
    currCardinalMoney: any = 0;//当前赔率
    tdCount = 0;//td总数除以2
    newDollarsBetting = [];
    newDollarsBetting2 = [];
    newDollarsBettingClone = [];
    bettingNoteHead = [];
    rewardUp = 0;
    currBonus = 0;
    minnum = 0;
    maxnum = 0;
    rangeValue = 0;
    BonusMode = [];
    baseReward = 0;
    groupAttr: any; //组选三组选六集合
    cardinalMoneyArry = []; //组选三组选六赔率集合

    // groupCheckParam  = {
    //     index: 0,
    //     count: 0,
    //     order: 0,
    //     cardinalMoneyAttr: [0, 0, 0]
    // }; //组选参数
    groupCheckParam: NumArray = new NumArray();
    // bettingMoneyCount = {
    //     noteTotal: 0,
    //     BettingMoney: 0,
    //     IssueNo: "",
    //     LotteryCode: "",
    //     IsChaseNo: 0,
    //     LotteryPlayModeCode: "",
    //     IsStopAfterWinning: 0,//0：中奖后不追号，1：中奖后继续追号
    //     BettingInfoIssueList: [],
    //     BettingInfoIssueString: "",
    //     BettingItemList: [],
    //     BettingItemString: ""
    // };//双面盘下注金额统计和注数集合

    bettingItemData: BettingMoneyCountModel = new BettingMoneyCountModel();
    isRefer = false;//下注是否提交
    shortcutStakeNumber = 50;

    constructor() {
        this.currlottery = new CurrLotteryModel();
    }

}

export class BettingMoneyCountModel {

    constructor() { }
    noteTotal: number = 0;
    BettingMoney: number = 0;
    rewardPar: number = 0;
    IssueNo: string = "";
    LotteryCode: string = "";
    IsChaseNo: number = 0;
    LotteryPlayModeCode: string = "";
    IsStopAfterWinning: number = 0;//0：中奖后不追号，1：中奖后继续追号
    BettingInfoIssueList: any[] = []
    BettingInfoIssueString: string = "";
    BettingItemList: any[] = [];
    BettingItemString: string = "";
}

export class CurrIssue {
    CurrentIssueNo: string;
    PreviewIssueNo: string;
    RemainTime: number;
    Issue: IssueModel;
}
export class IssueModel {
    BeginTime: Date;
    BeginTime1: Date;
    Crossdays: boolean;
    EndTime: Date;
    EndTime1: Date;
    IssueNo: string;
    LotteryCode: string;
    LotteryTypeCode: string;
    MaxIssue: number;
    MinIssue: number;
    NowIssueDay: Date;
}
export class PlayDetailModel {
    LotteryPlayDetailCode: string;
    LotteryPlayDetailName: string;
    LotteryPlayModeCode: string;
    State: string;
    SerialsID: number;
    AlgorithmCode: string;
    CardinalMoney: number;
    Modulus: number;
    CardinalMoney1: number;
    Modulus1: number;
    LimitBet: number;
    IsRewardFixed: boolean;
    IsAttached: boolean;
    PlayGroup: string;
    Algorithm: AlgorithmModel;
    PlayDetailAttacheds: PlayDetailAttachedModel[];
}
export class PlayDetailAttachedModel {
    NumKey: string;
    LotteryPlayDetailCode: string;
    CardinalMoney: number;
    Modulus: number;
    SerialsID: number;
}
export class AlgorithmModel {
    AlgorithmCode: string;
    AlgorithmName: string;
    SerialsID: number;
    AlgorithmTypeCode: string;
    BetNumLength: number;
    TipInfo: string;
    PickExample: string;
    AlgorithmType: AlgorithmTypeModel;
}
export class AlgorithmTypeModel {
    AlgorithmTypeCode: string;
    AlgorithmTypeName: string;
    State: string;
    LotteryTypeCode: string;
    SerialsID: number;
    PickMode: string;
    CanCommonRan: string;
}
export class historyModel {
    IssueNo: string;
    LotteryOpenNo: string;
}
export class NumArray {
    index: number = 0;
    count: number = 0;
    order: number = 0;
    cardinalMoneyAttr: Array<any> = [0, 0, 0];
}

export class InitParams {
    formatRemain = "00:00:00";
    openIssueno = "";
    openNum = "";
    currlottery = new CurrLotteryModel();
    currIssue = new CurrIssue();
    medianList = [];
    numList = [];
    commandList = [];
    checkList = [];
    data_sel = [];
    BettingCount = 0;
    Multiple = 1; //倍数
    YuanJiaoFen = 1; //元角分厘
    currPlayDetail = new PlayDetailModel();
    currAlgorithmType = new AlgorithmTypeModel();
    isrx = false;
    Reward = [];
    RewardPar = ""; //显示奖金部分
    ShowReward = 0;
    AdjustReward = 0;
    rewardUp = 0;
    rewardDown = 0;
    baseReward = 0;
    BetBoxNum = "";
    maxnum = 0;
    minnum = 0;
    rangeValue = 0;
    BonusMode = [];
    rangeFlag = false;
    AdjustRewardIsFix = 0;
    BetDatas = [];
    historyList: historyModel[];
    isShowOpen = false;
    isOk = true; //无catch
    bettingMoneys: number = 0; //购物篮中的订单总额
    normalReportList = []; //常规投注列表
    normalReportPageCounts = 0; //常规投注列表总数
    isShowNormal = false; //是否显示常规订单
    chaseParams: any; //我要追号的参数
    isShowChase = false;
    buytab = 1; //购彩蓝和历史开奖tab
    isShowTip = false; //玩法提示显示

    constructor() {
        this.currIssue = new CurrIssue();
        this.currlottery = new CurrLotteryModel();
        this.currPlayDetail = new PlayDetailModel();
        this.currAlgorithmType = new AlgorithmTypeModel();
    }

    initDetailPars() {
        this.medianList = [];
        this.numList = [];
        this.commandList = [];
        this.checkList = [];
        this.data_sel = [];
        this.BettingCount = 0;
        this.isrx = false;
        this.BetBoxNum = "";
    }
}

// // 玩法模型 BettingType
// export class BettingType {
//     Label: string;
//     LotteryPlayModeCode: string;
//     Params: any[];
//     newParam: any[];
//     isSelect: boolean;

// }


// WEBPACK FOOTER //
// ./src/pages/dollars/dollars.ts